// Generated from the routed Vue files in src/views/test.
// It is used only for search matching and does not change page content.

import comprehensiveMovementDisordersGeneTable from "./comprehensiveMovementDisordersGeneTable";

const testGeneMap = {
  "/test/HearingLoss": [
    "ABHD12",
    "ACTB",
    "ACTG1",
    "ADCY1",
    "ADGRV1",
    "AIFM1",
    "ALMS1",
    "ANKH",
    "ATP6V1B1",
    "BDP1",
    "BSND",
    "CABP2",
    "CACNA1D",
    "CCDC50",
    "CD164",
    "CDC14A",
    "CDH23",
    "CEACAM16",
    "CHD7",
    "CIB2",
    "CLDN14",
    "CLIC5",
    "CLPP",
    "CLRN1",
    "COCH",
    "COL11A1",
    "COL11A2",
    "COL2A1",
    "COL4A3",
    "COL4A4",
    "COL4A5",
    "COL4A6",
    "CRYM",
    "DCDC2",
    "DIABLO",
    "DIAPH1",
    "DIAPH3",
    "DNMT1",
    "DSPP",
    "EDN3",
    "EDNRB",
    "ELMOD3",
    "EPS8",
    "ESPN",
    "ESRRB",
    "EYA1",
    "EYA4",
    "FGF3",
    "FGFR1",
    "FGFR2",
    "FGFR3",
    "FOXI1",
    "GATA3",
    "GIPC3",
    "GJA1",
    "GJB2",
    "GJB3",
    "GJB6",
    "GPSM2",
    "GRHL2",
    "GRXCR1",
    "GSDME",
    "HARS1",
    "HARS2",
    "HGF",
    "HOMER2",
    "HSD17B4",
    "ILDR1",
    "KARS1",
    "KCNE1",
    "KCNJ10",
    "KCNQ1",
    "KCNQ4",
    "KITLG",
    "LARS2",
    "LHFPL5",
    "LRTOMT",
    "MARVELD2",
    "MCM2",
    "MIR96",
    "MITF",
    "MSRB3",
    "MYH14",
    "MYH9",
    "MYO15A",
    "MYO3A",
    "MYO6",
    "MYO7A",
    "NDP",
    "NLRP3",
    "OPA1",
    "OSBPL2",
    "OTOA",
    "OTOF",
    "OTOG",
    "OTOGL",
    "P2RX2",
    "PAX3",
    "PCDH15",
    "PDZD7",
    "PJVK",
    "PMP22",
    "PNPT1",
    "POLR1D",
    "POU3F4",
    "POU4F3",
    "PRPS1",
    "PTPRQ",
    "RDX",
    "RIPOR2",
    "S1PR2",
    "SALL1",
    "SEMA3E",
    "SERPINB6",
    "SIX1",
    "SIX5",
    "SLC17A8",
    "SLC26A4",
    "SLC26A5",
    "SLC33A1",
    "SLITRK6",
    "SMPX",
    "SNAI2",
    "SOX10",
    "SOX2",
    "STRC",
    "SYNE4",
    "TBC1D24",
    "TBX1",
    "TCOF1",
    "TECTA",
    "TFAP2A",
    "TIMM8A",
    "TJP2",
    "TMC1",
    "TMIE",
    "TMPRSS3",
    "TNC",
    "TPRN",
    "TRIOBP",
    "TSPEAR",
    "USH1C",
    "USH1G",
    "USH2A",
    "WFS1",
    "WHRN"
  ],
  "/test/Amyloidosis Panel": [
    "APCS",
    "APOA1",
    "APOA2",
    "APOA4",
    "APOC2",
    "APOC3",
    "APOE",
    "APP",
    "B2M",
    "CRP",
    "CST3",
    "FGA",
    "GPNMB",
    "GSN",
    "IL31RA",
    "ITM2B",
    "LECT2",
    "LGALS7",
    "LYZ",
    "MYD88",
    "NLRP3",
    "OSMR",
    "PRNP",
    "SAA1",
    "SAA2",
    "SAA4",
    "TGFBI",
    "TTR"
  ],
  "/test/AortopathyDisorders": [
    "ABL1",
    "ACTA2",
    "ADAMTS2",
    "ALDH18A1",
    "ATP6V0A2",
    "ATP7A",
    "B3GALT6",
    "B4GALT7",
    "CBS",
    "CHST14",
    "COL11A1",
    "COL11A2",
    "COL1A1",
    "COL1A2",
    "COL2A1",
    "COL3A1",
    "COL5A1",
    "COL5A2",
    "COL9A1",
    "COL9A2",
    "CRTAP",
    "DSE",
    "EFEMP2",
    "ELN",
    "FBLN5",
    "FBN1",
    "FBN2",
    "FKBP14",
    "FLNA",
    "FOXE3",
    "LTBP4",
    "MAT2A",
    "MED12",
    "MFAP5",
    "MYH11",
    "MYLK",
    "NOTCH1",
    "P3H1",
    "PLOD1",
    "PRDM5",
    "PRKG1",
    "PYCR1",
    "RASA1",
    "RIN2",
    "SKI",
    "SLC2A10",
    "SLC39A13",
    "SMAD3",
    "SMAD4",
    "SMAD6",
    "TGFB2",
    "TGFB3",
    "TGFBR1",
    "TGFBR2",
    "TRAF7",
    "ZNF469"
  ],
  "/test/Arrhythmias": [
    "ABCC9",
    "AKAP9",
    "ALG10B",
    "ANK2",
    "CACNA1C",
    "CACNA2D1",
    "CACNB2",
    "CALM1",
    "CALM2",
    "CALM3",
    "CASQ2",
    "CAV3",
    "FGF12",
    "GPD1L",
    "HCN4",
    "KCND2",
    "KCND3",
    "KCNE1",
    "KCNE2",
    "KCNE3",
    "KCNE5",
    "KCNH2",
    "KCNJ2",
    "KCNJ5",
    "KCNJ8",
    "KCNQ1",
    "PKP2",
    "RANGRF",
    "RYR2",
    "SCN10A",
    "SCN1B",
    "SCN2B",
    "SCN3B",
    "SCN4B",
    "SCN5A",
    "SEMA3A",
    "SLMAP",
    "SNTA1",
    "TRDN",
    "TRPM4"
  ],
  "/test/Cardiomyopathy": [
    "A2ML1",
    "ABCC9",
    "ACADVL",
    "ACTC1",
    "ACTN2",
    "AGL",
    "ALMS1",
    "ANKRD1",
    "BAG3",
    "BRAF",
    "CACNA1C",
    "CALR3",
    "CAV3",
    "CBL",
    "CHRM2",
    "CPT2",
    "CRYAB",
    "CSRP3",
    "CTF1",
    "CTNNA3",
    "DES",
    "DMD",
    "DNAJC19",
    "DOLK",
    "DSC2",
    "DSG2",
    "DSP",
    "DTNA",
    "ELAC2",
    "EMD",
    "EYA4",
    "FHL1",
    "FHL2",
    "FKRP",
    "FKTN",
    "FLNC",
    "GAA",
    "GATA4",
    "GATA6",
    "GATAD1",
    "GLA",
    "HCN4",
    "HRAS",
    "ILK",
    "JPH2",
    "JUP",
    "KRAS",
    "LAMA4",
    "LAMP2",
    "LDB3",
    "LMNA",
    "LRRC10",
    "MAP2K1",
    "MAP2K2",
    "MTO1",
    "MYBPC3",
    "MYH6",
    "MYH7",
    "MYL2",
    "MYL3",
    "MYLK2",
    "MYOM1",
    "MYOZ2",
    "MYPN",
    "NEBL",
    "NEXN",
    "NF1",
    "NKX2-5",
    "NPPA",
    "NRAS",
    "PDLIM3",
    "PKP2",
    "PLEKHM2",
    "PLN",
    "PRDM16",
    "PRKAG2",
    "PTPN11",
    "RAF1",
    "RASA1",
    "RBM20",
    "RIT1",
    "RRAS",
    "RYR2",
    "SCN5A",
    "SDHA",
    "SGCD",
    "SHOC2",
    "SLC22A5",
    "SOS1",
    "SOS2",
    "SPRED1",
    "TAFAZZIN",
    "TBX20",
    "TCAP",
    "TGFB3",
    "TMEM43",
    "TMEM70",
    "TMPO",
    "TNNC1",
    "TNNI3",
    "TNNT2",
    "TPM1",
    "TTN",
    "TTR",
    "TXNRD2",
    "VCL"
  ],
  "/test/Hyperlipidemia Panel": [
    "ABCA1",
    "ABCG5",
    "ABCG8",
    "AGPAT2",
    "ALMS1",
    "ANGPTL3",
    "APOA1",
    "APOA5",
    "APOB",
    "APOC2",
    "APOC3",
    "APOE",
    "BSCL2",
    "CETP",
    "CREB3L3",
    "CYP27A1",
    "GPD1",
    "GPIHBP1",
    "LCAT",
    "LDLR",
    "LDLRAP1",
    "LIPA",
    "LIPG",
    "LMF1",
    "LPL",
    "LMNA",
    "LRP6",
    "MTTP",
    "PCSK9",
    "PLIN1",
    "PNPLA2",
    "PPARG",
    "SAR1B"
  ],
  "/test/Congenital Heart Defect": [
    "ABL1",
    "ACTC1",
    "ACVR2B",
    "AKT3",
    "ALMS1",
    "ARL6",
    "ARMC4",
    "B9D1",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS5",
    "BBS7",
    "BBS9",
    "BCOR",
    "BRAF",
    "CBL",
    "CC2D2A",
    "DNAAF19",
    "CCDC114",
    "CCDC151",
    "CCDC28B",
    "CCDC39",
    "CCDC40",
    "DRC2",
    "CCN1",
    "CCNO",
    "CDK13",
    "CEP290",
    "CFAP298",
    "CFAP53",
    "CHD7",
    "CITED2",
    "CPS1",
    "CRELD1",
    "DNAAF1",
    "DNAAF2",
    "DNAAF3",
    "DNAAF4",
    "DNAAF5",
    "DNAH11",
    "DNAH5",
    "DNAH8",
    "DNAI1",
    "DNAI2",
    "DNAL1",
    "DRC1",
    "DTNA",
    "ELN",
    "EVC",
    "EVC2",
    "FLNA",
    "FOXF1",
    "FOXH1",
    "GATA4",
    "GATA5",
    "GATA6",
    "GDF1",
    "GJA1",
    "GPC3",
    "HAND1",
    "HAND2",
    "HRAS",
    "HUWE1",
    "INVS",
    "JAG1",
    "KIF7",
    "KMT5B",
    "KRAS",
    "LEFTY2",
    "MAP2K1",
    "MAP2K2",
    "MCIDAS",
    "MED13L",
    "MEIS2",
    "MKKS",
    "MKS1",
    "MMP21",
    "MYH6",
    "NEK8",
    "NKX2-5",
    "NKX2-6",
    "NME8",
    "NODAL",
    "NONO",
    "NOTCH1",
    "NOTCH2",
    "NPHP3",
    "NR2F2",
    "NRAS",
    "NSD1",
    "NTRK3",
    "OFD1",
    "PIK3CA",
    "PIK3R2",
    "PITX2",
    "PKD1L1",
    "PLD1",
    "PTPN11",
    "RAF1",
    "RAI1",
    "RBM10",
    "RIT1",
    "RPGRIP1L",
    "SEMA3E",
    "SHOC2",
    "SMAD6",
    "SOS1",
    "SPAG1",
    "TAB2",
    "TBX1",
    "TBX20",
    "TBX5",
    "TCTN2",
    "TLL1",
    "TMEM216",
    "TMEM231",
    "TMEM67",
    "TRAF7",
    "TRIM32",
    "TTC8",
    "WDPCP",
    "ZFPM2",
    "ZIC3"
  ],
  "/test/Familial Hypercholesterolemia": [
    "ABCG5",
    "ABCG8",
    "APOB",
    "LDLR",
    "LDLRAP1",
    "PCSK9"
  ],
  "/test/Noonan Syndrome": [
    "A2ML1",
    "BRAF",
    "CBL",
    "FHL1",
    "HRAS",
    "KRAS",
    "MAP2K1",
    "MAP2K2",
    "NF1",
    "NRAS",
    "PTPN11",
    "RAF1",
    "RASA1",
    "RIT1",
    "RRAS",
    "SHOC2",
    "SOS1",
    "SOS2",
    "SPRED1"
  ],
  "/test/Hypertrophic Cardiomyopathy": [
    "ACADVL",
    "ACTC1",
    "ACTN2",
    "AGL",
    "BAG3",
    "CACNA1C",
    "CALR3",
    "CAV3",
    "CPT2",
    "CSRP3",
    "CTNNA3",
    "DES",
    "ELAC2",
    "FHL1",
    "FLNC",
    "GAA",
    "GATA4",
    "GATA6",
    "GLA",
    "ILK",
    "JPH2",
    "LAMP2",
    "LDB3",
    "MTO1",
    "MYBPC3",
    "MYH6",
    "MYH7",
    "MYL2",
    "MYL3",
    "MYLK2",
    "MYOM1",
    "MYOZ2",
    "MYPN",
    "NEXN",
    "NKX2-5",
    "PDLIM3",
    "PLN",
    "PRKAG2",
    "RAF1",
    "RIT1",
    "TBX20",
    "TCAP",
    "TNNC1",
    "TNNI3",
    "TNNT2",
    "TPM1",
    "TTN",
    "TTR",
    "VCL"
  ],
  "/test/Dilated Cardiomyopathy": [
    "ABCC9",
    "ACTC1",
    "ACTN2",
    "ALMS1",
    "ANKRD1",
    "BAG3",
    "CAV3",
    "CHRM2",
    "CRYAB",
    "CSRP3",
    "CTF1",
    "DES",
    "DMD",
    "DNAJC19",
    "DOLK",
    "DSC2",
    "DSG2",
    "DSP",
    "EMD",
    "EYA4",
    "FHL2",
    "FKRP",
    "FKTN",
    "FLNC",
    "GATA4",
    "GATA6",
    "GATAD1",
    "ILK",
    "JUP",
    "LAMA4",
    "LAMP2",
    "LDB3",
    "LMNA",
    "LRRC10",
    "MYBPC3",
    "MYH6",
    "MYH7",
    "MYPN",
    "NEBL",
    "NEXN",
    "NPPA",
    "PDLIM3",
    "PKP2",
    "PLEKHM2",
    "PLN",
    "PRDM16",
    "RAF1",
    "RBM20",
    "RYR2",
    "SCN5A",
    "SDHA",
    "SGCD",
    "SLC22A5",
    "TAFAZZIN",
    "TBX20",
    "TCAP",
    "TMEM43",
    "TMPO",
    "TNNC1",
    "TNNI3",
    "TNNT2",
    "TPM1",
    "TTN",
    "TTR",
    "TXNRD2",
    "VCL"
  ],
  "/test/Arrhythmogenic Right Ventricular/Dysplasia": [
    "ACTN2",
    "CTNNA3",
    "DES",
    "DSC2",
    "DSG2",
    "DSP",
    "EMD",
    "FLNC",
    "GATA4",
    "GATA6",
    "JUP",
    "LDB3",
    "LMNA",
    "MTO1",
    "NKX2-5",
    "NPPA",
    "PKP2",
    "PLN",
    "PRKAG2",
    "RBM20",
    "RYR2",
    "SCN5A",
    "TGFB3",
    "TMEM43",
    "TNNI3",
    "TNNT2",
    "TTN"
  ],
  "/test/Left Ventricular Noncompaction": [
    "ACTC1",
    "ACTN2",
    "DNAJC19",
    "DSP",
    "DTNA",
    "HCN4",
    "LAMA4",
    "LAMP2",
    "LDB3",
    "MYBPC3",
    "MYH7",
    "PLEKHM2",
    "PLN",
    "PRDM16",
    "RYR2",
    "SCN5A",
    "TAFAZZIN",
    "TBX20",
    "TNNI3",
    "TNNT2",
    "TPM1",
    "VCL"
  ],
  "/test/Noonan Syndrome And Other RASopathies": [
    "A2ML1",
    "ACTB",
    "ACTG1",
    "BRAF",
    "CBL",
    "HRAS",
    "KAT6B",
    "KRAS",
    "LZTR1",
    "MAP2K1",
    "MAP2K2",
    "NF1",
    "NRAS",
    "NSUN2",
    "PPP1CB",
    "PTPN11",
    "RAF1",
    "RASA1",
    "RASA2",
    "RIT1",
    "RRAS",
    "SHOC2",
    "SOS1",
    "SOS2",
    "SPRED1",
    "TRAF7"
  ],
  "/test/Brugada Syndrome": [
    "ABCC9",
    "CACNA1C",
    "CACNA2D1",
    "CACNB2",
    "FGF12",
    "GPD1L",
    "HCN4",
    "KCND2",
    "KCND3",
    "KCNE3",
    "KCNE5",
    "KCNH2",
    "KCNJ8",
    "PKP2",
    "RANGRF",
    "SCN10A",
    "SCN1B",
    "SCN2B",
    "SCN3B",
    "SCN5A",
    "SEMA3A",
    "SLMAP",
    "TRPM4"
  ],
  "/test/Catecholaminergic Polymorphic Ventricular Tachycardia": [
    "ANK2",
    "CALM1",
    "CALM2",
    "CALM3",
    "CASQ2",
    "KCNJ2",
    "RYR2",
    "TRDN"
  ],
  "/test/Long QT Syndrome": [
    "AKAP9",
    "ALG10B",
    "ANK2",
    "CACNA1C",
    "CALM1",
    "CALM2",
    "CALM3",
    "CAV3",
    "KCNE1",
    "KCNE2",
    "KCNH2",
    "KCNJ2",
    "KCNJ5",
    "KCNQ1",
    "SCN4B",
    "SCN5A",
    "SNTA1"
  ],
  "/test/Short QT Syndrome": [
    "KCNH2",
    "KCNJ2",
    "KCNQ1"
  ],
  "/test/Aortopathy and Connective Tissue Disorders": [
    "ABL1",
    "ACTA2",
    "ADAMTS2",
    "ALDH18A1",
    "ATP6V0A2",
    "ATP7A",
    "B3GALT6",
    "B4GALT7",
    "CBS",
    "CHST14",
    "COL11A1",
    "COL11A2",
    "COL1A1",
    "COL1A2",
    "COL2A1",
    "COL3A1",
    "COL5A1",
    "COL5A2",
    "COL9A1",
    "COL9A2",
    "CRTAP",
    "DSE",
    "EFEMP2",
    "ELN",
    "FBLN5",
    "FBN1",
    "FBN2",
    "FKBP14",
    "FLNA",
    "FOXE3",
    "LTBP4",
    "MAT2A",
    "MED12",
    "MFAP5",
    "MYH11",
    "MYLK",
    "NOTCH1",
    "P3H1",
    "PLOD1",
    "PRDM5",
    "PRKG1",
    "PYCR1",
    "RASA1",
    "RIN2",
    "SKI",
    "SLC2A10",
    "SLC39A13",
    "SMAD3",
    "SMAD4",
    "SMAD6",
    "TGFB2",
    "TGFB3",
    "TGFBR1",
    "TGFBR2",
    "TRAF7",
    "ZNF469"
  ],
  "/test/Connective Tissue Disorders": [
    "ABCC6",
    "ABL1",
    "ACTA2",
    "ACVR1",
    "ADAMTS10",
    "ADAMTS17",
    "ADAMTS2",
    "ADAMTSL4",
    "AEBP1",
    "ALDH18A1",
    "ATP6V0A2",
    "ATP6V1A",
    "ATP6V1E1",
    "ATP7A",
    "B3GALT6",
    "B3GAT3",
    "B4GALT7",
    "BGN",
    "C1S",
    "CBS",
    "CHST14",
    "CHST3",
    "COG7",
    "COL11A1",
    "COL11A2",
    "COL12A1",
    "COL1A1",
    "COL1A2",
    "COL2A1",
    "COL3A1",
    "COL4A1",
    "COL5A1",
    "COL5A2",
    "COL9A1",
    "COL9A2",
    "COL9A3",
    "CRTAP",
    "DCHS1",
    "DSE",
    "EFEMP2",
    "ELN",
    "FBLN5",
    "FBN1",
    "FBN2",
    "FKBP14",
    "FLCN",
    "FLNA",
    "FLNB",
    "FOXE3",
    "GGCX",
    "GORAB",
    "HCN4",
    "LEMD3",
    "LOX",
    "LOXL3",
    "LTBP2",
    "LTBP3",
    "LTBP4",
    "MED12",
    "MFAP5",
    "MYH11",
    "MYLK",
    "NOG",
    "NOTCH1",
    "P3H1",
    "PKD2",
    "PLOD1",
    "PLOD3",
    "PRDM5",
    "PRKG1",
    "PYCR1",
    "RIN2",
    "SKI",
    "SLC26A2",
    "SLC2A10",
    "SLC39A13",
    "SMAD2",
    "SMAD3",
    "SMAD4",
    "SMAD6",
    "SPARC",
    "TALDO1",
    "TGFB1",
    "TGFB2",
    "TGFB3",
    "TGFBR1",
    "TGFBR2",
    "UPF3B",
    "ZNF469"
  ],
  "/test/Comprehensive Diabetes and Obesity": [
    "ABCC8",
    "APPL1",
    "BLK",
    "CEL",
    "DYRK1B",
    "EIF2AK3",
    "FOXP3",
    "GATA6",
    "GCK",
    "GLIS3",
    "HNF1A",
    "HNF1B",
    "HNF4A",
    "INS",
    "KCNJ11",
    "KLF11",
    "LEP",
    "LEPR",
    "MC4R",
    "NEUROD1",
    "NR0B2",
    "NTRK2",
    "PAX4",
    "PCSK1",
    "PDX1",
    "POMC",
    "PPARG",
    "PTF1A",
    "RFX6",
    "SIM1",
    "SLC19A2",
    "SLC2A2",
    "UCP3",
    "WFS1"
  ],
  "/test/Familial Hyperparathyroidism or Hypocalciuric Hypercalcemia Panel": [
    "AP2S1",
    "CASR",
    "CDC73",
    "CDKN1A",
    "CDKN1B",
    "CDKN2B",
    "CDKN2C",
    "GCM2",
    "GNA11",
    "MEN1",
    "RET"
  ],
  "/test/Hyperinsulinism Panel": [
    "ABCC8",
    "AKT2",
    "ALG3",
    "ALG6",
    "CACNA1D",
    "CREBBP",
    "EIF2S3",
    "EP300",
    "FOXA2",
    "GCK",
    "GLUD1",
    "GPC3",
    "HADH",
    "HK1",
    "HNF1A",
    "HNF4A",
    "HRAS",
    "INSR",
    "KCNJ11",
    "KCNQ1",
    "KDM6A",
    "KMT2D",
    "MAFA",
    "MPI",
    "NFIX",
    "NSD1",
    "PGM1",
    "PMM2",
    "SLC16A1",
    "TRMT10A",
    "UCP2",
    "USH1C"
  ],
  "/test/Maturity-Onset Diabetes of the Young": [
    "ABCC8",
    "APPL1",
    "BLK",
    "CEL",
    "GCK",
    "HNF1A",
    "HNF1B",
    "HNF4A",
    "INS",
    "KCNJ11",
    "KLF11",
    "NEUROD1",
    "PAX4",
    "PDX1"
  ],
  "/test/Neonatal Diabetes Mellitus": [
    "ABCC8",
    "EIF2AK3",
    "FOXP3",
    "GATA6",
    "GCK",
    "GLIS3",
    "HNF1B",
    "HNF4A",
    "INS",
    "KCNJ11",
    "NEUROD1",
    "PDX1",
    "PTF1A",
    "RFX6",
    "SLC19A2",
    "SLC2A2",
    "WFS1"
  ],
  "/test/Inherited Obesity": [
    "DYRK1B",
    "LEP",
    "LEPR",
    "MC4R",
    "NR0B2",
    "NTRK2",
    "PCSK1",
    "POMC",
    "PPARG",
    "SIM1",
    "UCP3"
  ],
  "/test/Hereditary Liver Disease": [
    "ABB11",
    "ABCB4",
    "ABCC2",
    "ABCD3",
    "ACADM",
    "ACADVL",
    "ACOX2",
    "ADK",
    "AGL",
    "AGPAT2",
    "AKR1D1",
    "ALAD",
    "ALDOB",
    "AMACR",
    "ASL",
    "ASS1",
    "ATP7B",
    "ATP8B1",
    "BAAT",
    "BCS1L",
    "BSCL2",
    "CAVIN1",
    "CC2D2A",
    "CCDC115",
    "CFTR",
    "CLDN1",
    "COG1",
    "COG6",
    "COG7",
    "CPS1",
    "CPT1A",
    "CPT2",
    "CYP27A1",
    "CYP7A1",
    "CYP7B1",
    "DCDC2",
    "DGUOK",
    "DLD",
    "EIF2AK3",
    "EPHX1",
    "ETFA",
    "ETFB",
    "ETFDH",
    "FAH",
    "FARS2",
    "G6PC1",
    "GAA",
    "GALE",
    "GALT",
    "GBA1",
    "GBE1",
    "GFM1",
    "GYS2",
    "HADHA",
    "HMGCL",
    "HSD3B7",
    "IARS1",
    "INVS",
    "JAG1",
    "KRT18",
    "KRT8",
    "LARS1",
    "LIPA",
    "LMNA",
    "MARS1",
    "MPI",
    "MPV17",
    "MRPS16",
    "MYO5B",
    "NBAS",
    "NGLY1",
    "NOTCH2",
    "NPC1",
    "NPC2",
    "NR1H4",
    "OTC",
    "PEX1",
    "PEX10",
    "PEX12",
    "PEX13",
    "PEX14",
    "PEX16",
    "PEX19",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PEX7",
    "PGM1",
    "PHKA1",
    "PHKA2",
    "PHKB",
    "PHKG2",
    "PKD1",
    "PKD2",
    "PKHD1",
    "PKLR",
    "PMM2",
    "POLG",
    "PYGL",
    "RPGRIP1L",
    "SBDS",
    "SCO1",
    "SCYL1",
    "SERPINA1",
    "SLC10A1",
    "SLC10A2",
    "SLC25A13",
    "SLC25A20",
    "SLC27A5",
    "SLC37A4",
    "SLC39A8",
    "SMPD1",
    "STT3B",
    "SUCLG1",
    "TJP2",
    "TMEM67",
    "TRMU",
    "TSFM",
    "SKIC3",
    "TWNK",
    "TYMP",
    "VIPAS39",
    "VPS33B"
  ],
  "/test/Ashkenazi Jewish Carrier Screening Panel": [
    "ABCC8",
    "ASPA",
    "BCKDHB",
    "BLM",
    "CFTR",
    "CLRN1",
    "ELP1",
    "FANCC",
    "G6PC1",
    "GBA1",
    "HEXA",
    "MCOLN1",
    "PCDH15",
    "SMPD1",
    "TMEM216"
  ],
  "/test/Healthy Screening Basic": [
    "ABCC8",
    "ABCG5",
    "ABCG8",
    "ABL1",
    "ACTA2",
    "ACTC1",
    "ACVRL1",
    "APC",
    "APOB",
    "APPL1",
    "ASPA",
    "ATM",
    "ATP7B",
    "BAG3",
    "BCKDHA",
    "BCKDHB",
    "BEST1",
    "BLK",
    "BLM",
    "BMPR1A",
    "BRCA1",
    "BRCA2",
    "BRIP1",
    "BTD",
    "C1QTNF5",
    "CACNA1S",
    "CASQ2",
    "CDH1",
    "CDH23",
    "CDKN2A",
    "CEL",
    "CFTR",
    "CHEK2",
    "CLRN1",
    "COCH",
    "COL3A1",
    "CTNNA1",
    "DBT",
    "DES",
    "DSC2",
    "DSG2",
    "DSP",
    "DYRK1B",
    "ENG",
    "EPCAM",
    "EYA4",
    "FANCC",
    "FBN1",
    "FH",
    "FLCN",
    "FLNC",
    "G6PC",
    "GAA",
    "GBA1",
    "GCK",
    "GLA",
    "HBB",
    "HEXA",
    "HFE",
    "HNF1A",
    "HNF1B",
    "HNF4A",
    "IKBKAP (ELP1)",
    "IMPG1",
    "IMPG2",
    "INS",
    "KCNH2",
    "KCNJ11",
    "KCNQ1",
    "KLF11",
    "LDLR",
    "LDLRAP1",
    "LEP",
    "LEPR",
    "LMNA",
    "MAX",
    "MC4R",
    "MCOLN1",
    "MEN1",
    "MLH1",
    "MSH2",
    "MSH6",
    "MUTYH",
    "MYBPC3",
    "MYH11",
    "MYH7",
    "MYL2",
    "MYL3",
    "NEUROD1",
    "NF1",
    "NF2",
    "NPC1",
    "NROB2",
    "NTRK2",
    "OTC",
    "PALB2",
    "PAX4",
    "PCDH15",
    "PCSK1",
    "PCSK9",
    "PDX1",
    "PKP2",
    "PMS2",
    "POMC",
    "POU4F3",
    "PPARG",
    "PRKAG2",
    "PRPH2",
    "PTEN",
    "RAD51C",
    "RAD51D",
    "RB1",
    "RBM20",
    "RET",
    "RPE65",
    "RYR1",
    "RYR2",
    "SCN5A",
    "SDHAF2",
    "SDHB",
    "SDHC",
    "SDHD",
    "SIM1",
    "SLC17A8",
    "SMAD3",
    "SMAD4",
    "SMPD1",
    "STK11",
    "TGFBR1",
    "TGFBR2",
    "TMEM127",
    "TMEM216",
    "TMEM43",
    "TNNC1",
    "TNNI3",
    "TNNT2",
    "TP53",
    "TPM1",
    "TRAF7",
    "TRDN",
    "TSC1",
    "TSC2",
    "TTN",
    "TTR",
    "UCP3",
    "USH2A",
    "VHL",
    "WFS1",
    "WT1"
  ],
  "/test/Healthy Screening Expanded": [
    "A2ML1",
    "ABCC8",
    "ABCC9",
    "ABCG5",
    "ABCG8",
    "ABL1",
    "ACADVL",
    "ACTA2",
    "ACTC1",
    "ACTN2",
    "ACVRL1",
    "ADAMTS2",
    "AGL",
    "AKAP9",
    "ALDH18A1",
    "ALG10B",
    "ALMS1",
    "ANK2",
    "ANKRD1",
    "APC",
    "APOB",
    "APPL1",
    "ASPA",
    "ATM",
    "ATP6V0A2",
    "ATP7A",
    "ATP7B",
    "B3GALT6",
    "B4GALT7",
    "BAG3",
    "BAP1",
    "BARD1",
    "BCKDHA",
    "BCKDHB",
    "BEST1",
    "BLK",
    "BLM",
    "BMPR1A",
    "BRAF",
    "BRCA1",
    "BRCA2",
    "BRIP1",
    "BTD",
    "C1QTNF5",
    "CACNA1C",
    "CACNA1S",
    "CACNA2D1",
    "CACNB2",
    "CALM1",
    "CALM2",
    "CALM3",
    "CALR3",
    "CASQ2",
    "CAV3",
    "CBL",
    "CBS",
    "CDH1",
    "CDH23",
    "CDK4",
    "CDKN2A",
    "CEL",
    "CFT1",
    "CFTR",
    "CHEK2",
    "CHRM2",
    "CHST14",
    "CLRN1",
    "COCH",
    "COL11A1",
    "COL11A2",
    "COL1A1",
    "COL1A2",
    "COL2A1",
    "COL3A1",
    "COL5A1",
    "COL5A2",
    "COL9A1",
    "COL9A2",
    "CPT2",
    "CRTAP",
    "CRYAB",
    "CSRP3",
    "CTNNA1",
    "CTNNA3",
    "DBT",
    "DES",
    "DMD",
    "DNAJC19",
    "DOLK",
    "DSC2",
    "DSE",
    "DSG2",
    "DSP",
    "DTNA",
    "DYRK1B",
    "EFEMP2",
    "ELAC2",
    "ELN",
    "EMD",
    "ENG",
    "EPCAM",
    "EYA4",
    "FANCC",
    "FBLN5",
    "FBN1",
    "FBN2",
    "FGF12",
    "FH",
    "FHL1",
    "FHL2",
    "FKBP14",
    "FKRP",
    "FKTN",
    "FLCN",
    "FLNA",
    "FLNC",
    "FOXE3",
    "G6PC",
    "GAA",
    "GATA4",
    "GATA6",
    "GATAD1",
    "GBA1",
    "GCK",
    "GLA",
    "GPD1L",
    "GREM1",
    "HBB",
    "HCN4",
    "HEXA",
    "HFE",
    "HNF1A",
    "HNF1B",
    "HNF4A",
    "HRAS",
    "IKBKAP (ELP1)",
    "ILK",
    "IMPG1",
    "IMPG2",
    "INS",
    "JPH2",
    "JUP",
    "KCND2",
    "KCND3",
    "KCNE1",
    "KCNE2",
    "KCNE5",
    "KCNH2",
    "KCNJ11",
    "KCNJ2",
    "KCNJ5",
    "KCNJ8",
    "KCNQ1",
    "KLF11",
    "KNCE3",
    "KRAS",
    "LAMA4",
    "LAMP2",
    "LDB3",
    "LDLR",
    "LDLRAP1",
    "LEP",
    "LEPR",
    "LMNA",
    "LRRC10",
    "LTBP4",
    "MAP2K1",
    "MAP2K2",
    "MAT2A",
    "MAX",
    "MC4R",
    "MCOLN1",
    "MED12",
    "MEN1",
    "MFAP5",
    "MITF",
    "MLH1",
    "MSH2",
    "MSH6",
    "MTO1",
    "MUTYH",
    "MYBPC3",
    "MYH11",
    "MYH6",
    "MYH7",
    "MYL2",
    "MYL3",
    "MYLK",
    "MYLK2",
    "MYOM1",
    "MYOZ2",
    "MYPN",
    "NBN",
    "NEBL",
    "NEUROD1",
    "NEXN",
    "NF1",
    "NF2",
    "NKX2-5",
    "NOTCH1",
    "NPC1",
    "NPPA",
    "NRAS",
    "NROB2",
    "NTRK2",
    "OTC",
    "P3H1",
    "PALB2",
    "PAX4",
    "PCDH15",
    "PCSK1",
    "PCSK9",
    "PDLIM3",
    "PDX1",
    "PKP2",
    "PLEKHM2",
    "PLN",
    "PLOD1",
    "PMS2",
    "POLD1",
    "POLE",
    "POMC",
    "POU4F3",
    "PPARG",
    "PRDM16",
    "PRDM5",
    "PRKAG2",
    "PRKG1",
    "PRPH2",
    "PTEN",
    "PTPN11",
    "PYCR1",
    "RAD50",
    "RAD51C",
    "RAD51D",
    "RAF1",
    "RANGRF",
    "RASA1",
    "RB1",
    "RBM20",
    "RET",
    "RIN2",
    "RIT1",
    "RPE65",
    "RRAS",
    "RYR1",
    "RYR2",
    "SCN10A",
    "SCN1B",
    "SCN2B",
    "SCN3B",
    "SCN4B",
    "SCN5A",
    "SDHA",
    "SDHAF2",
    "SDHB",
    "SDHC",
    "SDHD",
    "SEMA3A",
    "SGCD",
    "SHOC2",
    "SIM1",
    "SKI",
    "SLC17A8",
    "SLC22A5",
    "SLC2A10",
    "SLC39A13",
    "SLMAP",
    "SMAD3",
    "SMAD4",
    "SMAD6",
    "SMPD1",
    "SNTA1",
    "SOS1",
    "SOS2",
    "SPRED1",
    "STK11",
    "TAX",
    "TBX20",
    "TCAP",
    "TGFB2",
    "TGFB3",
    "TGFBR1",
    "TGFBR2",
    "TMEM127",
    "TMEM216",
    "TMEM43",
    "TMEM70",
    "TMPO",
    "TNNC1",
    "TNNI3",
    "TNNT2",
    "TP53",
    "TPM1",
    "TRAF7",
    "TRDN",
    "TRPM4",
    "TSC1",
    "TSC2",
    "TTN",
    "TTR",
    "TXNRD2",
    "UCP3",
    "USH2A",
    "VCL",
    "VHL",
    "WFS1",
    "WT1",
    "ZNF469"
  ],
  "/test/Anemia": [
    "ABCB7",
    "ADAMTS13",
    "AK1",
    "ALAS2",
    "ALDOA",
    "ANK1",
    "ATP11C",
    "BPGM",
    "BRCA1",
    "BRCA2",
    "BRIP1",
    "C3",
    "CASP10",
    "CD46",
    "CD59",
    "CDAN1",
    "CDIN1",
    "CFB",
    "CFH",
    "CFHR1",
    "CFHR3",
    "CFI",
    "COX4I2",
    "CPOX",
    "DEF6",
    "DGKE",
    "DHFR",
    "EPB41",
    "EPB42",
    "EPO",
    "ERCC4",
    "FANCA",
    "FANCB",
    "FANCC",
    "FANCD2",
    "FANCE",
    "FANCF",
    "FANCG",
    "FANCI",
    "FANCL",
    "FAS",
    "FASLG",
    "G6PD",
    "GATA1",
    "GCLC",
    "GLRX5",
    "GPI",
    "GPX1",
    "GSR",
    "GSS",
    "HBA1",
    "HBA2",
    "HBB",
    "HEATR3",
    "HK1",
    "HMOX1",
    "HSCB",
    "HSPA9",
    "IFNG",
    "IREB2",
    "KCNN4",
    "KIF23",
    "KLF1",
    "LARS2",
    "LCAT",
    "LCP2",
    "LRBA",
    "MAD2L2",
    "MPIG6B",
    "MTHFD1",
    "MTR",
    "MTRR",
    "NBN",
    "NHLRC2",
    "NT5C3A",
    "PALB2",
    "PGK1",
    "PIEZO1",
    "PIGA",
    "PIGT",
    "PKLR",
    "PRF1",
    "PSMG2",
    "PUS1",
    "RACGAP1",
    "RAD51",
    "RAD51C",
    "RFWD3",
    "RHAG",
    "RHCE",
    "RPL11",
    "RPL15",
    "RPL18",
    "RPL26",
    "RPL27",
    "RPL35",
    "RPL35A",
    "RPL5",
    "RPS10",
    "RPS14",
    "RPS15A",
    "RPS17",
    "RPS19",
    "RPS24",
    "RPS26",
    "RPS27",
    "RPS28",
    "RPS29",
    "RPS7",
    "SASH3",
    "SBDS",
    "SEC23B",
    "SLC10A1",
    "SLC11A2",
    "SLC19A1",
    "SLC19A2",
    "SLC25A38",
    "SLC2A1",
    "SLC4A1",
    "SLX4",
    "SOCS1",
    "SPTA1",
    "SPTB",
    "STEAP3",
    "STIM1",
    "TDO2",
    "THBD",
    "TJP2",
    "TMPRSS6",
    "TPI1",
    "TPP2",
    "TRNT1",
    "TSR2",
    "UBE2T",
    "UROS",
    "XRCC2",
    "YARS2"
  ],
  "/test/Bleeding Disorders": [
    "ABCG5",
    "ABCG8",
    "ACTN1",
    "ADAMTS13",
    "ANKRD26",
    "ANO6",
    "AP3B1",
    "ARPC1B",
    "BLOC1S3",
    "BLOC1S6",
    "CD36",
    "CYCS",
    "DTNBP1",
    "EFL1",
    "ETV6",
    "F10",
    "F11",
    "F12",
    "F13A1",
    "F13B",
    "F2",
    "F5",
    "F7",
    "F8",
    "F9",
    "FGA",
    "FGB",
    "FGG",
    "FLI1",
    "FLNA",
    "FYB1",
    "GATA1",
    "GBA1",
    "GFI1B",
    "GGCX",
    "GP1BA",
    "GP1BB",
    "GP6",
    "GP9",
    "HOXA11",
    "HPS1",
    "HPS3",
    "HPS4",
    "HPS5",
    "HPS6",
    "ITGA2",
    "ITGA2B",
    "ITGB3",
    "KLKB1",
    "KNG1",
    "LMAN1",
    "LYST",
    "MASTL",
    "MCFD2",
    "MECOM",
    "MPL",
    "MYH9",
    "NBEAL2",
    "P2RY12",
    "PLAU",
    "PLG",
    "PRKACG",
    "PROC",
    "PROS1",
    "RASGRP2",
    "RBM8A",
    "RUNX1",
    "SERPINC1",
    "SERPINE1",
    "SERPINF2",
    "SLFN14",
    "SMPD1",
    "SRC",
    "SRP54",
    "TBXA2R",
    "TBXAS1",
    "THBD",
    "THPO",
    "TUBB1",
    "VKORC1",
    "VWF",
    "WAS",
    "WIPF1"
  ],
  "/test/Bone Marrow Failure Disorders": [
    "ABCB7",
    "ACD",
    "ACTB",
    "ADA",
    "ADA2",
    "AK2",
    "ALAS2",
    "ANKRD26",
    "AP3B1",
    "ATM",
    "ATR",
    "BLM",
    "BRCA1",
    "BRCA2",
    "BRIP1",
    "CBL",
    "CD40",
    "CD40LG",
    "CDAN1",
    "CEBPA",
    "CEBPE",
    "CLPB",
    "CSF3R",
    "CTC1",
    "CTLA4",
    "CXCR2",
    "CXCR4",
    "CYCS",
    "DCLRE1B",
    "DDX41",
    "DKC1",
    "DNAJC21",
    "DUT",
    "EFL1",
    "ELANE",
    "EPCAM",
    "EPO",
    "ERCC4",
    "ERCC6L2",
    "ETV6",
    "FANCA",
    "FANCB",
    "FANCC",
    "FANCD2",
    "FANCE",
    "FANCF",
    "FANCG",
    "FANCI",
    "FANCL",
    "G6PC1",
    "G6PC3",
    "GATA1",
    "GATA2",
    "GFI1",
    "GLRX5",
    "GP1BA",
    "HAX1",
    "HOXA11",
    "HTRA2",
    "IKZF1",
    "ITGA2B",
    "ITGB3",
    "ITK",
    "JAGN1",
    "KIF23",
    "KIT",
    "KLF1",
    "KRAS",
    "LAMTOR2",
    "LIG4",
    "LYST",
    "MAD2L2",
    "MBD4",
    "MDM4",
    "MECOM",
    "MLH1",
    "MPL",
    "MSH2",
    "MSH6",
    "MTHFD1",
    "MYH9",
    "MYSM1",
    "NAF1",
    "NBEAL2",
    "NBN",
    "NF1",
    "NHP2",
    "NOP10",
    "NRAS",
    "PALB2",
    "PARN",
    "PAX5",
    "PGM3",
    "PIEZO1",
    "PMS2",
    "POT1",
    "PRF1",
    "PTPN11",
    "PUS1",
    "RAB27A",
    "RAC2",
    "RAD51",
    "RAD51C",
    "RBM8A",
    "RECQL4",
    "RFWD3",
    "RMRP",
    "RPA1",
    "RPL11",
    "RPL15",
    "RPL18",
    "RPL26",
    "RPL27",
    "RPL35",
    "RPL35A",
    "RPL5",
    "RPS10",
    "RPS17",
    "RPS19",
    "RPS24",
    "RPS26",
    "RPS27",
    "RPS28",
    "RPS29",
    "RPS7",
    "RTEL1",
    "RUNX1",
    "SAMD9",
    "SAMD9L",
    "SBDS",
    "SEC23B",
    "SH2D1A",
    "SLC19A2",
    "SLC25A38",
    "SLC37A4",
    "SLX4",
    "SMARCAL1",
    "SMARCD2",
    "SRP54",
    "SRP72",
    "STIM1",
    "STK4",
    "STN1",
    "STXBP2",
    "TAFAZZIN",
    "TBXAS1",
    "TCIRG1",
    "TCN2",
    "TERC",
    "TERT",
    "TET2",
    "THPO",
    "TIMM50",
    "TINF2",
    "TLR8",
    "TP53",
    "TRNT1",
    "TSR2",
    "TUBB1",
    "UBE2T",
    "UNC13D",
    "USB1",
    "VPS13B",
    "VPS45",
    "WAS",
    "WDR1",
    "WIPF1",
    "WRAP53",
    "XIAP",
    "XRCC2",
    "ZCCHC8"
  ],
  "/test/Fanconi Anemia": [
    "ATM",
    "ATR",
    "BLM",
    "BRCA1",
    "BRCA2",
    "BRIP1",
    "CXCR4",
    "ERCC4",
    "ERCC6L2",
    "FANCA",
    "FANCB",
    "FANCC",
    "FANCD2",
    "FANCE",
    "FANCF",
    "FANCG",
    "FANCI",
    "FANCL",
    "MAD2L2",
    "NBN",
    "PALB2",
    "RAD51",
    "RAD51C",
    "RFWD3",
    "SLX4",
    "UBE2T",
    "XRCC2"
  ],
  "/test/F8 Inversion": [
    "F8"
  ],
  "/test/Platelet Disease": [
    "ACTN1",
    "ADAMTS13",
    "ANKRD26",
    "ANO6",
    "AP3B1",
    "ARPC1B",
    "BLOC1S3",
    "BLOC1S6",
    "CD36",
    "CYCS",
    "DTNBP1",
    "EPHB2",
    "ETV6",
    "FERMT3",
    "FLI1",
    "FLNA",
    "GATA1",
    "GBA1",
    "GFI1B",
    "GP1BA",
    "GP1BB",
    "GP6",
    "GP9",
    "HOXA11",
    "HPS1",
    "HPS3",
    "HPS4",
    "HPS5",
    "HPS6",
    "ITGA2",
    "ITGA2B",
    "ITGB3",
    "LYST",
    "MPL",
    "MYH9",
    "NBEA",
    "NBEAL2",
    "P2RX1",
    "P2RY12",
    "PLA2G4A",
    "PLAU",
    "RASGRP2",
    "RBM8A",
    "RUNX1",
    "SLFN14",
    "TBXA2R",
    "TBXAS1",
    "THPO",
    "TUBB1",
    "VWF",
    "WAS",
    "WIPF1"
  ],
  "/test/Autoimmunity and Autoinflammatory Disease": [
    "ACP5",
    "ADA",
    "ADA2",
    "ADAM17",
    "ADAR",
    "AICDA",
    "AIRE",
    "AP1S3",
    "AP3B1",
    "BLOC1S6",
    "BTK",
    "C1NH",
    "CARD14",
    "CASP10",
    "CASP8",
    "CD27",
    "CD3G",
    "CD40LG",
    "CEBPE",
    "COPA",
    "CR2",
    "CTLA4",
    "CYBA",
    "CYBB",
    "DCLRE1C",
    "DDX58",
    "DKC1",
    "DNASE1",
    "DNASE1L3",
    "DOCK8",
    "FAS",
    "FASLG",
    "FGR",
    "FOXP3",
    "ICOS",
    "IFIH1",
    "IL10",
    "IL10RA",
    "IL10RB",
    "IL1RN",
    "IL21",
    "IL21R",
    "IL2RA",
    "IL2RG",
    "IL36RN",
    "ITCH",
    "ITGB2",
    "ITK",
    "LIG4",
    "LPIN2",
    "LRBA",
    "LYST",
    "MAGT1",
    "MEFV",
    "MVK",
    "NCF2",
    "NCF4",
    "NFKB2",
    "NFKBIA",
    "NLRC4",
    "NLRP1",
    "NLRP12",
    "NLRP3",
    "NOD2",
    "OTULIN",
    "PIK3CD",
    "PIK3R1",
    "PLCG2",
    "PNP",
    "POLA1",
    "POMP",
    "PRF1",
    "PRKCD",
    "PSMA3",
    "PSMB4",
    "PSMB8",
    "PSMB9",
    "PSTPIP1",
    "RAB27A",
    "RAG1",
    "RAG2",
    "RBCK1",
    "RIPK1",
    "RTEL1",
    "SAMHD1",
    "SH2D1A",
    "SH3BP2",
    "SLC29A3",
    "STAT3",
    "STIM1",
    "STING1",
    "STX11",
    "STXBP2",
    "TBX1",
    "TNFAIP3",
    "TNFRSF1A",
    "TREX1",
    "TRNT1",
    "TTC7A",
    "UNC13D",
    "USP18",
    "WAS",
    "XIAP",
    "ZAP70"
  ],
  "/test/Hemophagocytic Lymphohistiocytosis Panel": [
    "ADA",
    "AP3B1",
    "AP3D1",
    "BLOC1S6",
    "BTK",
    "CD27",
    "CD70",
    "CDC42",
    "CORO1A",
    "CTPS1",
    "CYBA",
    "CYBB",
    "CYBC1",
    "FADD",
    "FAS",
    "FASLG",
    "GATA2",
    "HAVCR2",
    "IFNAR2",
    "IL2RA",
    "IL2RG",
    "ITK",
    "LAMP1",
    "LIPA",
    "LYST",
    "MAGT1",
    "MEFV",
    "MVK",
    "MYO5A",
    "NCF2",
    "NCF4",
    "NCKAP1L",
    "NLRC4",
    "NLRP3",
    "PNP",
    "PRF1",
    "RAB27A",
    "RASGRP1",
    "RC3H1",
    "RECQL4",
    "RHOG",
    "SH2D1A",
    "SLC7A7",
    "STX11",
    "STXBP2",
    "TBXAS1",
    "TNFRSF1A",
    "UNC13D",
    "WAS",
    "XIAP",
    "ZNFX1"
  ],
  "/test/Neutropenia Panel": [
    "AK2",
    "AP3B1",
    "CD40LG",
    "CLPB",
    "CSF3R",
    "CXCR2",
    "CXCR4",
    "DNAJC21",
    "EFL1",
    "EIF2AK3",
    "ELANE",
    "G6PC3",
    "GATA1",
    "GATA2",
    "GFI1",
    "HAX1",
    "HBA1",
    "HBA2",
    "HYOU1",
    "JAGN1",
    "LAMTOR2",
    "LYST",
    "MRTFA",
    "RUNX1",
    "SBDS",
    "SLC37A4",
    "SMARCD2",
    "SRP54",
    "STK4",
    "TAFAZZIN",
    "TCIRG1",
    "TCN2",
    "TP53",
    "USB1",
    "VPS13B",
    "VPS45",
    "WAS",
    "WDR1",
    "WIPF1"
  ],
  "/test/Primary Immunodeficiencies and Cytopenia": [
    "ABCB7",
    "ABCG5",
    "ABCG8",
    "ACD",
    "ACP5",
    "ACTB",
    "ACTG1",
    "ACTN1",
    "ADA",
    "ADA2",
    "ADAM17",
    "ADAMTS13",
    "ADAMTS3",
    "ADAR",
    "AICDA",
    "AIRE",
    "AK2",
    "ALAS2",
    "ANKRD11",
    "ANKRD26",
    "AP1S3",
    "AP3B1",
    "AP3D1",
    "APOL1",
    "ARHGEF1",
    "ARPC1B",
    "ATM",
    "ATP6AP1",
    "ATR",
    "ATRX",
    "B2M",
    "BACH2",
    "BCL10",
    "BCL11B",
    "BLM",
    "BLNK",
    "BLOC1S3",
    "BLOC1S6",
    "BTK",
    "C1QA",
    "C1QB",
    "C1QC",
    "C2",
    "C3",
    "C5",
    "C6",
    "C7",
    "C8A",
    "C8B",
    "C9",
    "CARD11",
    "CARD14",
    "CARD9",
    "CARMIL2",
    "CASP10",
    "CASP8",
    "CBL",
    "CCBE1",
    "CD19",
    "CD247",
    "CD27",
    "CD3D",
    "CD3E",
    "CD3G",
    "CD40",
    "CD40LG",
    "CD46",
    "CD55",
    "CD59",
    "CD70",
    "CD79A",
    "CD79B",
    "CD81",
    "CDAN1",
    "CDC42",
    "CEBPA",
    "CEBPE",
    "CFB",
    "CFD",
    "CFH",
    "CFI",
    "CFP",
    "CFTR",
    "CHD7",
    "CIITA",
    "CLCN7",
    "CLEC7A",
    "CLPB",
    "COG6",
    "COPA",
    "CORO1A",
    "CR2",
    "CREBBP",
    "CSF3R",
    "CTC1",
    "CTLA4",
    "CTNNBL1",
    "CTPS1",
    "CTSC",
    "CXCR4",
    "CYBA",
    "CYBB",
    "CYCS",
    "CYP27A1",
    "DCLRE1C",
    "DDX41",
    "DDX58",
    "DEF6",
    "DGKE",
    "DHFR",
    "DKC1",
    "DNASE1L3",
    "DNASE2",
    "DNMT3B",
    "DOCK2",
    "DOCK8",
    "EIF2AK3",
    "ELANE",
    "EP300",
    "EPG5",
    "ERCC2",
    "ERCC4",
    "ETV6",
    "EXTL3",
    "FADD",
    "FANCA",
    "FANCB",
    "FANCC",
    "FANCD2",
    "FANCE",
    "FANCF",
    "FANCG",
    "FANCI",
    "FANCL",
    "FAS",
    "FASLG",
    "FCGR3A",
    "FCN3",
    "FERMT3",
    "FLI1",
    "FOXN1",
    "FOXP3",
    "FYB1",
    "G6PC3",
    "G6PD",
    "GATA1",
    "GATA2",
    "GBA1",
    "GFI1",
    "GFI1B",
    "GLRX5",
    "GP1BA",
    "GP1BB",
    "GP9",
    "GRAP2",
    "GRB2",
    "GYPC",
    "HAX1",
    "HCLA",
    "ICOS",
    "ICOSLG",
    "IFNAR2",
    "IFNG",
    "IFNGR1",
    "IFNGR2",
    "IGF1R",
    "IKBKAP",
    "IKZF1",
    "IKZF2",
    "IKZF3",
    "IL10",
    "IL10RA",
    "IL10RB",
    "IL12B",
    "IL12RB1",
    "IL15RA",
    "IL21",
    "IL21R",
    "IL2RA",
    "IL2RG",
    "IL6ST",
    "IL7R",
    "IRAK4",
    "IRF8",
    "ITGB2",
    "ITK",
    "JAK1",
    "JAK3",
    "KAT6A",
    "KCNT1",
    "KIT",
    "LAMTOR2",
    "LAT",
    "LAX1",
    "LCK",
    "LIG4",
    "LOX",
    "LRBA",
    "LYST",
    "MAGT1",
    "MANAO",
    "MAVS",
    "MEFV",
    "MRE11A",
    "MSH2",
    "MSH6",
    "MT-CYB",
    "MYD88",
    "NBN",
    "NCF1",
    "NCF2",
    "NCF4",
    "NFKB1",
    "NFKB2",
    "NFKBIA",
    "NHEJ1",
    "NOX1",
    "NSUN2",
    "OAS1",
    "OSGEP",
    "PAK1",
    "PAX5",
    "PCSK9",
    "PFN1",
    "PIK3CD",
    "PIK3R1",
    "PKD1",
    "PKD2",
    "PLCG2",
    "PML",
    "PNP",
    "POLE",
    "POLG",
    "PRF1",
    "PRKCD",
    "PSEN1",
    "PTEN",
    "PTPN2",
    "PTPN6",
    "PTPRC",
    "PYHIN1",
    "RAB27A",
    "RAG1",
    "RAG2",
    "RASA2",
    "REL",
    "RHOH",
    "RNASEH2C",
    "RPA1",
    "RTEL1",
    "SAMHD1",
    "SBDS",
    "SC5BC1",
    "SEC61A1",
    "SELP",
    "SH2D1A",
    "SIK2",
    "SLC18A2",
    "SLC29A3",
    "SLC37A4",
    "SMARCAL1",
    "SMARCB1",
    "SP110",
    "SPRED1",
    "STIM1",
    "STING1",
    "STX11",
    "STXBP2",
    "SUGT1",
    "SYK",
    "TBX1",
    "TCR\u03b1",
    "TCR\u03b2",
    "TERC",
    "TERT",
    "TET2",
    "TFN",
    "TNFAIP3",
    "TNFRSF1A",
    "TOP3A",
    "TP53",
    "TP63",
    "TRAC",
    "TRBC",
    "TREX1",
    "TRNT1",
    "TSC1",
    "TSC2",
    "TYK2",
    "UNC13D",
    "USP18",
    "VPS13B",
    "WAS",
    "WHN",
    "WIPF1",
    "XIAP",
    "XPO1",
    "ZAP70",
    "ZBTB24"
  ],
  "/test/Lysosomal Storage Disease": [
    "ABCC8",
    "ABCD1",
    "ABHD5",
    "ACOX1",
    "ACY1",
    "ADAMTS10",
    "ADAMTSL2",
    "ADSL",
    "AGA",
    "ALDH5A1",
    "ALDH7A1",
    "AMACR",
    "AMT",
    "ANTXR2",
    "AP3B1",
    "ARG1",
    "ARSA",
    "ARSB",
    "ASAH1",
    "ASPA",
    "ATG5",
    "ATP13A2",
    "ATP6AP1",
    "BLOC1S3",
    "BLOC1S6",
    "BTD",
    "CLCN5",
    "CLN3",
    "CLN5",
    "CLN6",
    "CLN8",
    "COL11A2",
    "COL2A1",
    "CTNS",
    "CTSA",
    "CTSC",
    "CTSD",
    "CTSF",
    "CTSK",
    "DHCR7",
    "DNAJC5",
    "DNM1L",
    "DPYD",
    "DTNBP1",
    "DYM",
    "ETFA",
    "ETFB",
    "ETFDH",
    "FAR1",
    "FBN1",
    "FH",
    "FIG4",
    "FOLR1",
    "FUCA1",
    "GAA",
    "GALC",
    "GALNS",
    "GAMT",
    "GBA1",
    "GCDH",
    "GLA",
    "GLB1",
    "GLDC",
    "GM2A",
    "GNE",
    "GNPAT",
    "GNPTAB",
    "GNPTG",
    "GNS",
    "GPC3",
    "GRN",
    "GUSB",
    "HEXA",
    "HEXB",
    "HGSNAT",
    "HPS1",
    "HPS3",
    "HPS4",
    "HPS5",
    "HPS6",
    "HRAS",
    "HSD17B4",
    "HYAL1",
    "IDS",
    "IDUA",
    "KCTD7",
    "KMT2D",
    "L2HGDH",
    "LAMA2",
    "LAMP2",
    "LDB3",
    "LIPA",
    "LTBP2",
    "LYST",
    "MAN1B1",
    "MAN2B1",
    "MANBA",
    "MBTPS1",
    "MCOLN1",
    "MFSD8",
    "MLPH",
    "MOCS1",
    "MOCS2",
    "MYO5A",
    "MYOT",
    "NAGA",
    "NAGLU",
    "NEU1",
    "NPC1",
    "NPC2",
    "NPR2",
    "OCRL",
    "PEX1",
    "PEX10",
    "PEX11B",
    "PEX12",
    "PEX13",
    "PEX14",
    "PEX16",
    "PEX19",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PEX7",
    "PGK1",
    "PHYH",
    "PNPLA2",
    "PPT1",
    "PRODH",
    "PSAP",
    "QDPR",
    "RAB27A",
    "RAI1",
    "SCARB2",
    "SCP2",
    "SGSH",
    "SLC17A5",
    "SLC25A15",
    "SLC46A1",
    "SLC9A6",
    "SMPD1",
    "SUMF1",
    "SUOX",
    "TCF4",
    "TPP1",
    "TRIM37",
    "VPS33A"
  ],
  "/test/Comprehensive Renal Disease": [
    "ACE",
    "ACTG2",
    "ACTN4",
    "AGT",
    "AGTR1",
    "AGXT",
    "AHI1",
    "ALMS1",
    "AMN",
    "ANKS6",
    "ANOS1",
    "ARHGDIA",
    "ARL13B",
    "ARL6",
    "ARMC9",
    "ATP6V1B1",
    "B9D2",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS5",
    "BBS7",
    "BBS9",
    "BNC2",
    "BSND",
    "C3",
    "CC2D2A",
    "CD46",
    "CENPF",
    "CEP104",
    "CEP164",
    "CEP290",
    "CEP41",
    "CEP83",
    "CFB",
    "CFH",
    "CFHR1",
    "CFHR3",
    "CFHR5",
    "CFI",
    "CHD7",
    "CILK1",
    "CLCN5",
    "COL4A1",
    "COL4A3",
    "COL4A4",
    "COL4A5",
    "COQ2",
    "COQ6",
    "COQ8B",
    "CPLANE1",
    "CRB2",
    "CSPP1",
    "CTNS",
    "CUBN",
    "DDX59",
    "DGKE",
    "DHCR7",
    "DLC1",
    "DNAJB11",
    "DSTYK",
    "DYNC2H1",
    "DYNC2I1",
    "DZIP1L",
    "EMP2",
    "EYA1",
    "FAN1",
    "FAT1",
    "FRAS1",
    "FREM1",
    "FREM2",
    "GANAB",
    "GATA3",
    "GATM",
    "GLA",
    "GLI3",
    "GRHPR",
    "GRIP1",
    "HAAO",
    "HNF1B",
    "HOGA1",
    "HPSE2",
    "HYLS1",
    "IFT122",
    "IFT43",
    "INF2",
    "INPP5E",
    "INVS",
    "IQCB1",
    "ITGA3",
    "ITGA8",
    "ITSN1",
    "KIAA0586",
    "KIAA0753",
    "KIF7",
    "KYNU",
    "LAGE3",
    "LAMB2",
    "LMX1B",
    "LRIG2",
    "LZTFL1",
    "MAGI2",
    "MAPKBP1",
    "MKKS",
    "MKS1",
    "MMACHC",
    "MUC1",
    "MYH9",
    "MYO1E",
    "NEK8",
    "NPHP1",
    "NPHP3",
    "NPHP4",
    "NPHS1",
    "NPHS2",
    "NUP107",
    "NUP133",
    "NUP85",
    "NUP93",
    "OCRL",
    "OFD1",
    "OSGEP",
    "PAX2",
    "PBX1",
    "PKD1",
    "PKD2",
    "PKHD1",
    "PLCE1",
    "PMM2",
    "PODXL",
    "REN",
    "RET",
    "RPGRIP1L",
    "RRM2B",
    "SALL1",
    "SCARB2",
    "SDCCAG8",
    "SEC61A1",
    "SGPL1",
    "SIX5",
    "SLC22A12",
    "SLC2A9",
    "SLC3A1",
    "SLC7A9",
    "SMARCAL1",
    "TBC1D8B",
    "TBX18",
    "TCTN1",
    "TCTN2",
    "TCTN3",
    "TMEM107",
    "TMEM138",
    "TMEM216",
    "TMEM231",
    "TMEM237",
    "TMEM67",
    "TP53RK",
    "TRAF3IP1",
    "TRPC6",
    "TSC1",
    "TSC2",
    "TTC21B",
    "TTC8",
    "TXNDC15",
    "UMOD",
    "VHL",
    "VPS33B",
    "WDPCP",
    "WDR19",
    "WDR35",
    "WDR73",
    "WT1",
    "XDH"
  ],
  "/test/Dystonia Panel": [
    "ADCY5",
    "ANO3",
    "ATP1A3",
    "ATP7B",
    "BCAP31",
    "CACNA1B",
    "CIZ1",
    "COL6A3",
    "CYP27A1",
    "DCAF17",
    "DDC",
    "DNAJC12",
    "FA2H",
    "FITM2",
    "GCH1",
    "GNAL",
    "GNAO1",
    "HEXA",
    "HPCA",
    "KCNMA1",
    "KCTD17",
    "KMT2B",
    "MECR",
    "PANK2",
    "PDGFB",
    "PDGFRB",
    "PLA2G6",
    "PNKD",
    "PRKN",
    "PRKRA",
    "PRRT2",
    "SCP2",
    "SGCE",
    "SLC2A1",
    "SLC30A10",
    "SLC39A14",
    "SLC6A3",
    "SPR",
    "TAF1",
    "TH",
    "THAP1",
    "TOR1A",
    "TUBB4A",
    "VAC14",
    "VPS13A",
    "XPR1"
  ],
  "/test/Amyotrophic Lateral Sclerosis Panel": [
    "ALS2",
    "ANXA11",
    "AR",
    "ATXN2",
    "C9orf72",
    "CHCHD10",
    "CHMP2B",
    "DCTN1",
    "ERLIN1",
    "ERLIN2",
    "FUS",
    "GRN",
    "HNRNPA2B1",
    "KIFSA",
    "LRP12",
    "MATR3",
    "NEK1",
    "OPTN",
    "PFN1",
    "SLC52A2",
    "SLC52A3",
    "SOD1",
    "SPG11",
    "SPTLC2",
    "SQSTM1",
    "TARDBP",
    "TBK1",
    "TUBA4A",
    "UBQLN2",
    "VAPB",
    "VCP"
  ],
  "/test/Cerebral Cavernous Malformations Panel": [
    "CCM2",
    "KRIT1",
    "PDCD10"
  ],
  "/test/Leukodystrophy and Leukoencephalopathy Panel": [
    "AARS2",
    "ABAT",
    "ABCA1",
    "ABCD1",
    "ACOX1",
    "ACP5",
    "ADAR",
    "ADGRG1",
    "ADK",
    "ADSL",
    "AGA",
    "AIFM1",
    "AIMP1",
    "AIMP2",
    "ALDH3A2",
    "ALDH5A1",
    "AP4B1",
    "AP4E1",
    "AP4M1",
    "AP4S1",
    "ARCN1",
    "ARHGAP31",
    "ARSA",
    "ASPA",
    "ASXL1",
    "ASXL2",
    "ATP7A",
    "ATP7B",
    "AUH",
    "B3GALNT2",
    "BCAP31",
    "BCL11B",
    "BOLA3",
    "BPTF",
    "BRAT1",
    "C2CD3",
    "CBS",
    "CCDC88A",
    "CLCN2",
    "CLN6",
    "CLPP",
    "CNNM2",
    "COA7",
    "COA8",
    "COL4A1",
    "COL4A2",
    "COLGALT1",
    "COQ2",
    "COQ9",
    "COX10",
    "COX15",
    "COX6B1",
    "CPS1",
    "CRIPT",
    "CRLF1",
    "CSF1R",
    "CTC1",
    "CTNS",
    "CTSA",
    "CYB5R3",
    "CYP27A1",
    "CYP2U1",
    "CYP7B1",
    "D2HGDH",
    "DAG1",
    "DARS1",
    "DARS2",
    "DCAF17",
    "DDHD2",
    "DEGS1",
    "DGUOK",
    "DMXL2",
    "DNM1L",
    "DONSON",
    "EARS2",
    "EIF2B1",
    "EIF2B2",
    "EIF2B3",
    "EIF2B4",
    "EIF2B5",
    "EPRS1",
    "ERCC6",
    "ERCC8",
    "ETFA",
    "ETFB",
    "ETFDH",
    "EXOSC8",
    "FA2H",
    "FARS2",
    "FBXL4",
    "FDX2",
    "FH",
    "FKRP",
    "FOLR1",
    "FOXRED1",
    "FUCA1",
    "GALC",
    "GALT",
    "GAN",
    "GCDH",
    "GFAP",
    "GFM1",
    "GJA1",
    "GJB1",
    "GJC2",
    "GLA",
    "GLB1",
    "GLRX5",
    "GLYCTK",
    "GMNN",
    "HACE1",
    "HEPACAM",
    "HEXA",
    "HIBCH",
    "HIKESHI",
    "HMGCL",
    "HNRNPU",
    "HSD17B4",
    "HSPD1",
    "HTRA1",
    "HYCC1",
    "IBA57",
    "IDH2",
    "IDS",
    "IFIH1",
    "ISCA2",
    "ITPA",
    "JAM3",
    "KARS1",
    "KCNJ10",
    "KCNT1",
    "KDM1A",
    "KIAA0586",
    "L2HGDH",
    "LAGE3",
    "LAMA1",
    "LAMA2",
    "LIPT2",
    "LMNB1",
    "LONP1",
    "LRPPRC",
    "LYRM7",
    "MAG",
    "MARS2",
    "MCOLN1",
    "MED17",
    "MLC1",
    "MLYCD",
    "MOCS1",
    "MPV17",
    "MRPL44",
    "MRPS22",
    "MTFMT",
    "MTHFR",
    "MTHFS",
    "MTOR",
    "NACC1",
    "NADK2",
    "NAXD",
    "NAXE",
    "NDUFA1",
    "NDUFA10",
    "NDUFA11",
    "NDUFA12",
    "NDUFA2",
    "NDUFA9",
    "NDUFAF1",
    "NDUFAF2",
    "NDUFAF3",
    "NDUFAF4",
    "NDUFAF5",
    "NDUFAF6",
    "NDUFB3",
    "NDUFB8",
    "NDUFS1",
    "NDUFS2",
    "NDUFS3",
    "NDUFS4",
    "NDUFS6",
    "NDUFS7",
    "NDUFS8",
    "NDUFV1",
    "NDUFV2",
    "NEK1",
    "NFU1",
    "NKX6-2",
    "NOTCH1",
    "NPC1",
    "NPC2",
    "NT5C2",
    "NUBPL",
    "OCRL",
    "OSGEP",
    "OTC",
    "PAH",
    "PC",
    "PDHA1",
    "PET100",
    "PEX1",
    "PEX10",
    "PEX11B",
    "PEX12",
    "PEX13",
    "PEX14",
    "PEX16",
    "PEX19",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PHGDH",
    "PIGP",
    "PLAA",
    "PLEKHG2",
    "PLP1",
    "POLG",
    "POLR1A",
    "POLR1C",
    "POLR3A",
    "POLR3B",
    "PPP1R15B",
    "PPP2R1A",
    "PPP3CA",
    "PPT1",
    "PRKDC",
    "PRPS1",
    "PSAP",
    "PTEN",
    "PUS3",
    "PYCR2",
    "RARS1",
    "RERE",
    "RNASEH2A",
    "RNASEH2B",
    "RNASEH2C",
    "RNASET2",
    "RNF216",
    "RPIA",
    "RRM2B",
    "SAMD9L",
    "SAMHD1",
    "SCO1",
    "SCP2",
    "SDHA",
    "SDHAF1",
    "SDHB",
    "SERAC1",
    "SLC12A5",
    "SLC16A2",
    "SLC17A5",
    "SLC19A3",
    "SLC1A2",
    "SLC1A4",
    "SLC25A1",
    "SLC25A12",
    "SLC25A15",
    "SLC25A4",
    "SLC6A9",
    "SNIP1",
    "SNORD118",
    "SNRPB",
    "SON",
    "SOX10",
    "SOX2",
    "SPART",
    "SPG11",
    "SPG7",
    "STAMBP",
    "STN1",
    "STXBP1",
    "SUCLA2",
    "SUMF1",
    "SURF1",
    "TACO1",
    "TAF2",
    "TARS2",
    "TBCD",
    "TBCE",
    "TBCK",
    "TIMMDC1",
    "TM4SF20",
    "TMEM106B",
    "TMEM126B",
    "TMTC3",
    "TP53RK",
    "TRAPPC11",
    "TREM2",
    "TREX1",
    "TTC19",
    "TUBB4A",
    "TUFM",
    "TWNK",
    "TXN2",
    "TYMP",
    "TYROBP",
    "UFM1",
    "UPB1",
    "VARS2",
    "VPS11",
    "VPS33A",
    "WARS2",
    "WDR73",
    "YME1L1",
    "ZFYVE26"
  ],
  "/test/Paroxysmal Dyskinesia Panel": [
    "ECHS1",
    "KCNMA1",
    "PNKD",
    "PRRT2",
    "RHOBTB2",
    "SCN8A",
    "SLC2A1",
    "TBC1D24",
    "TMEM151A"
  ],

  "/test/Corneal Dystrophy Panel": [
    "AGBL1",
    "CHRDL1",
    "CHST6",
    "COL17A1",
    "COL5A1",
    "COL8A2",
    "CYP4V2",
    "DCN",
    "FOXE3",
    "GJA8",
    "GRHL2",
    "GSN",
    "KERA",
    "KRT12",
    "KRT3",
    "LCAT",
    "LOXHD1",
    "MAF",
    "OVOL2",
    "PAX6",
    "PIKFYVE",
    "PITX2",
    "PRDM5",
    "SLC4A11",
    "TACSTD2",
    "TCF4",
    "TGFBI",
    "UBIAD1",
    "VSX1",
    "ZEB1",
    "ZNF469"
  ],
  "/test/Hypoglycemia Panel": [
    "AAAS",
    "ABCC8",
    "ABCD1",
    "ACAD9",
    "ACADM",
    "ACADS",
    "ACADSB",
    "ACADVL",
    "ACAT1",
    "ACSF3",
    "ADK",
    "AGL",
    "AKT2",
    "ALDOA",
    "ALDOB",
    "ALG3",
    "ALG6",
    "ATP7A",
    "BCKDHA",
    "BCKDHB",
    "CA5A",
    "CACNA1C",
    "CACNA1D",
    "CDKN1C",
    "COG7",
    "CPT1A",
    "CPT2",
    "CYP7B1",
    "DBH",
    "DBT",
    "DDC",
    "DGUOK",
    "DLD",
    "DMXL2",
    "DOLK",
    "ENO3",
    "EPM2A",
    "ETFA",
    "ETFB",
    "ETFDH",
    "FAH",
    "FBP1",
    "FLAD1",
    "G6PC1",
    "GAA",
    "GALE",
    "GALK1",
    "GALT",
    "GBE1",
    "GCK",
    "GH1",
    "GHR",
    "GLUD1",
    "GPC3",
    "GYG1",
    "GYS1",
    "GYS2",
    "HADH",
    "HADHA",
    "HADHB",
    "HESX1",
    "HK1",
    "HMGCL",
    "HMGCS2",
    "HNF1A",
    "HNF4A",
    "HRAS",
    "HSD17B10",
    "HSD3B7",
    "INSR",
    "KCNJ11",
    "KDM6A",
    "KMT2D",
    "LAMP2",
    "LDHA",
    "LHX3",
    "MLYCD",
    "MPI",
    "MPV17",
    "NADK2",
    "NHLRC1",
    "NNT",
    "NR0B1",
    "NR3C1",
    "NSD1",
    "OPLAH",
    "OTX2",
    "OXCT1",
    "PC",
    "PCK1",
    "PCK2",
    "PCSK1",
    "PDX1",
    "PFKM",
    "PGAM2",
    "PGK1",
    "PGM1",
    "PHGDH",
    "PHKA1",
    "PHKA2",
    "PHKB",
    "PHKG2",
    "PMM2",
    "POMC",
    "PRKAG2",
    "PROP1",
    "PTF1A",
    "PYGL",
    "PYGM",
    "RBCK1",
    "SERAC1",
    "SLC16A1",
    "SLC22A5",
    "SLC25A20",
    "SLC25A32",
    "SLC2A2",
    "SLC37A4",
    "SLC52A1",
    "SLC52A2",
    "SLC52A3",
    "SOX2",
    "SOX3",
    "TAFAZZIN",
    "TBX19",
    "TRMT10A",
    "UCP2"
  ],

  "/test/Seizure Panel": [
    "AARS1",
    "ABAT",
    "ABCA2",
    "ABCD1",
    "ACTL6B",
    "ACY1",
    "ADAM22",
    "ADAR",
    "ADNP",
    "ADPRS",
    "ADSL",
    "AFG2A",
    "AFG3L2",
    "AGA",
    "AIFM1",
    "AIMP1",
    "ALDH3A2",
    "ALDH5A1",
    "ALDH7A1",
    "ALG1",
    "ALG12",
    "ALG13",
    "ALG6",
    "ALKBH8",
    "AMACR",
    "AMT",
    "ANKRD11",
    "AP2M1",
    "AP3B2",
    "AP4B1",
    "AP4E1",
    "AP4M1",
    "AP4S1",
    "ARG1",
    "ARHGEF9",
    "ARID1B",
    "ARSA",
    "ARV1",
    "ARX",
    "ASAH1",
    "ASNS",
    "ASPA",
    "ASXL3",
    "ATAD1",
    "ATP13A2",
    "ATP1A1",
    "ATP1A2",
    "ATP1A3",
    "ATP6AP2",
    "ATP6V1A",
    "ATP7A",
    "ATRX",
    "BCKDK",
    "BRAT1",
    "BTD",
    "C12orf57",
    "CACNA1A",
    "CACNA1B",
    "CACNA1C",
    "CACNA1D",
    "CACNA1E",
    "CACNA1G",
    "CACNA1H",
    "CACNA2D2",
    "CACNB4",
    "CAD",
    "CAMK2B",
    "CARS2",
    "CASK",
    "CASR",
    "CC2D1A",
    "CCDC88A",
    "CDK9",
    "CDKL5",
    "CERS1",
    "CERT1",
    "CHD2",
    "CHRNA2",
    "CHRNA4",
    "CHRNA7",
    "CHRNB2",
    "CILK1",
    "CLCN2",
    "CLCN4",
    "CLCN6",
    "CLN3",
    "CLN5",
    "CLN6",
    "CLN8",
    "CLTC",
    "CNKSR2",
    "CNPY3",
    "CNTN2",
    "CNTNAP2",
    "COA7",
    "COA8",
    "COG5",
    "COL18A1",
    "COL4A1",
    "COL4A2",
    "COQ2",
    "COQ4",
    "COX15",
    "COX6B1",
    "CPLX1",
    "CPS1",
    "CPT2",
    "CSF1R",
    "CSNK2B",
    "CSTB",
    "CTC1",
    "CTNNB1",
    "CTSD",
    "CTSF",
    "CUL4B",
    "CUX2",
    "CYFIP2",
    "CYP27A1",
    "D2HGDH",
    "DARS1",
    "DARS2",
    "DCX",
    "DDC",
    "DDX3X",
    "DEAF1",
    "DEGS1",
    "DENND5A",
    "DEPDC5",
    "DHDDS",
    "DHFR",
    "DHPS",
    "DIAPH1",
    "DMXL2",
    "DNAJC5",
    "DNM1",
    "DNM1L",
    "DOCK6",
    "DOCK7",
    "DOLK",
    "DPAGT1",
    "DPM1",
    "DPM2",
    "DPYD",
    "DPYS",
    "DYNC1H1",
    "DYRK1A",
    "EARS2",
    "ECHS1",
    "ECM1",
    "EEF1A2",
    "EFHC1",
    "EHMT1",
    "EIF2B1",
    "EIF2B2",
    "EIF2B3",
    "EIF2B4",
    "EIF2B5",
    "EIF3F",
    "EMC1",
    "EML1",
    "EPM2A",
    "EPRS1",
    "ETFA",
    "ETFB",
    "ETFDH",
    "ETHE1",
    "FA2H",
    "FAR1",
    "FARS2",
    "FBXO11",
    "FDFT1",
    "FDX2",
    "FGF12",
    "FH",
    "FKTN",
    "FLNA",
    "FOLR1",
    "FOXG1",
    "FOXP1",
    "FOXRED1",
    "FRRS1L",
    "FUT8",
    "GABBR2",
    "GABRA1",
    "GABRA2",
    "GABRB1",
    "GABRB2",
    "GABRB3",
    "GABRG2",
    "GALC",
    "GAMT",
    "GATAD2B",
    "GATM",
    "GCDH",
    "GCH1",
    "GCSH",
    "GFAP",
    "GFM1",
    "GFM2",
    "GJC2",
    "GLB1",
    "GLDC",
    "GLRA1",
    "GLRB",
    "GLS",
    "GLUD1",
    "GNAO1",
    "GNB1",
    "GNE",
    "GOLGA2",
    "GOSR2",
    "GPAA1",
    "GPHN",
    "GRIA3",
    "GRIA4",
    "GRIK2",
    "GRIN1",
    "GRIN2A",
    "GRIN2B",
    "GRIN2D",
    "GRN",
    "GTPBP3",
    "GUF1",
    "HACE1",
    "HCN1",
    "HCN2",
    "HDAC8",
    "HECW2",
    "HEPACAM",
    "HEXA",
    "HIBCH",
    "HIVEP2",
    "HNRNPU",
    "HSD17B10",
    "HSPD1",
    "HTRA1",
    "HTT",
    "HYCC1",
    "IBA57",
    "IER3IP1",
    "IFIH1",
    "IQSEC2",
    "IRF2BPL",
    "ITPA",
    "KANSL1",
    "KCNA1",
    "KCNA2",
    "KCNB1",
    "KCNC1",
    "KCND2",
    "KCNH1",
    "KCNH2",
    "KCNH5",
    "KCNJ10",
    "KCNK4",
    "KCNMA1",
    "KCNQ2",
    "KCNQ3",
    "KCNQ5",
    "KCNT1",
    "KCNT2",
    "KCTD3",
    "KCTD7",
    "KDM5C",
    "KDM6A",
    "KIF1A",
    "KIF2A",
    "KIF5A",
    "KIF5C",
    "KMT2E",
    "KPNA7",
    "L1CAM",
    "L2HGDH",
    "LAMC3",
    "LGI1",
    "LIAS",
    "LMNB1",
    "LMNB2",
    "LNPK",
    "LRPPRC",
    "LYRM7",
    "MACF1",
    "MAGI2",
    "MARS2",
    "MBD5",
    "MBOAT7",
    "MDH2",
    "MECP2",
    "MED12",
    "MED17",
    "MEF2C",
    "MFSD8",
    "MICAL1",
    "MIPEP",
    "MLC1",
    "MOCS1",
    "MOCS2",
    "MRPL44",
    "MTFMT",
    "MTHFR",
    "MTOR",
    "NACC1",
    "NAGLU",
    "NALCN",
    "NBEA",
    "NDST1",
    "NDUFAF3",
    "NDUFAF5",
    "NDUFAF6",
    "NDUFS2",
    "NDUFS4",
    "NDUFS6",
    "NDUFS7",
    "NDUFS8",
    "NDUFV1",
    "NECAP1",
    "NEDD4L",
    "NEU1",
    "NEUROD2",
    "NEXMIF",
    "NFU1",
    "NGLY1",
    "NHLRC1",
    "NKX6-2",
    "NOTCH3",
    "NPC1",
    "NPC2",
    "NPRL2",
    "NPRL3",
    "NR2F1",
    "NRXN1",
    "NSDHL",
    "NT5C2",
    "NTRK2",
    "NUBPL",
    "NUS1",
    "OCLN",
    "OFD1",
    "OPHN1",
    "P4HTM",
    "PACS1",
    "PACS2",
    "PAFAH1B1",
    "PARS2",
    "PCDH19",
    "PCLO",
    "PEX1",
    "PEX10",
    "PEX12",
    "PEX13",
    "PEX14",
    "PEX16",
    "PEX19",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PGK1",
    "PHACTR1",
    "PHF6",
    "PHGDH",
    "PIGA",
    "PIGB",
    "PIGC",
    "PIGG",
    "PIGN",
    "PIGO",
    "PIGP",
    "PIGQ",
    "PIGS",
    "PIGT",
    "PIGV",
    "PIGW",
    "PITRM1",
    "PLAA",
    "PLCB1",
    "PLP1",
    "PLPBP",
    "PNKD",
    "PNKP",
    "PNPO",
    "PNPT1",
    "POLG",
    "POLR3A",
    "POLR3B",
    "PPP2CA",
    "PPP2R1A",
    "PPP2R5D",
    "PPP3CA",
    "PPT1",
    "PRICKLE1",
    "PRICKLE2",
    "PRIMA1",
    "PRODH",
    "PRRT2",
    "PRUNE1",
    "PSAP",
    "PSAT1",
    "PSPH",
    "PTEN",
    "PTPN23",
    "PTS",
    "PUM1",
    "PURA",
    "PYCR2",
    "QARS1",
    "QDPR",
    "RAB11A",
    "RAB11B",
    "RAB39B",
    "RAI1",
    "RALA",
    "RANBP2",
    "RARS1",
    "RELN",
    "RFT1",
    "RHOBTB2",
    "RMND1",
    "RNASEH2A",
    "RNASEH2B",
    "RNASEH2C",
    "RNASET2",
    "RNF13",
    "RNF216",
    "ROGDI",
    "RORA",
    "RORB",
    "RUSC2",
    "SAMHD1",
    "SATB2",
    "SCARB2",
    "SCN1A",
    "SCN1B",
    "SCN2A",
    "SCN3A",
    "SCN8A",
    "SCN9A",
    "SCO1",
    "SCP2",
    "SDHAF1",
    "SERAC1",
    "SERPINI1",
    "SETBP1",
    "SETD1B",
    "SGCE",
    "SGSH",
    "SHANK3",
    "SIK1",
    "SLC12A5",
    "SLC13A5",
    "SLC19A3",
    "SLC1A2",
    "SLC1A4",
    "SLC25A1",
    "SLC25A12",
    "SLC25A15",
    "SLC25A22",
    "SLC25A42",
    "SLC2A1",
    "SLC35A1",
    "SLC35A2",
    "SLC39A8",
    "SLC46A1",
    "SLC6A1",
    "SLC6A5",
    "SLC6A8",
    "SLC9A6",
    "SMARCA2",
    "SMC1A",
    "SMS",
    "SNAP25",
    "SNORD118",
    "SNX27",
    "SOX10",
    "SPTAN1",
    "SPTBN4",
    "SSR4",
    "ST3GAL3",
    "ST3GAL5",
    "STAG2",
    "STRADA",
    "STX1B",
    "STXBP1",
    "STXBP2",
    "SUMF1",
    "SUOX",
    "SURF1",
    "SYN1",
    "SYNGAP1",
    "SYNJ1",
    "SZT2",
    "TAF1",
    "TANGO2",
    "TBC1D20",
    "TBC1D24",
    "TBCD",
    "TBCE",
    "TBCK",
    "TBL1XR1",
    "TCF4",
    "TH",
    "TK2",
    "TPK1",
    "TPP1",
    "TRAK1",
    "TREX1",
    "TRIM8",
    "TRIT1",
    "TSC1",
    "TSC2",
    "TSFM",
    "TTC19",
    "TUBA1A",
    "TUBB2A",
    "TUBB2B",
    "TUBB4A",
    "UBA5",
    "UBE2A",
    "UBE3A",
    "UBTF",
    "UNC80",
    "VAMP2",
    "VARS1",
    "VPS13A",
    "VPS53",
    "WARS2",
    "WASF1",
    "WDR26",
    "WDR45",
    "WWOX",
    "YWHAG",
    "YY1",
    "ZDHHC9",
    "ZEB2",
    "ZFYVE26",
    "ZNHIT3",
    "ZSWIM6"
  ],
  "/test/Microcephaly Panel": [
    "AAAS",
    "AARS1",
    "ABCC8",
    "ABCD1",
    "ACADSB",
    "ACD",
    "ACE",
    "ACO2",
    "ACSL4",
    "ACTB",
    "ACTG1",
    "ACTG2",
    "ADAR",
    "ADAT3",
    "ADD3",
    "ADNP",
    "ADSL",
    "AFG2A",
    "AGA",
    "AGGF1",
    "AGMO",
    "AGT",
    "AGTR1",
    "AGTR2",
    "AIMP1",
    "AKT3",
    "ALDH18A1",
    "ALDH3A2",
    "ALDH6A1",
    "ALG1",
    "ALG11",
    "ALG13",
    "ALG3",
    "ALG9",
    "ALX1",
    "ALX4",
    "AMPD2",
    "ANK1",
    "ANKLE2",
    "ANKRD11",
    "AP3B1",
    "AP4B1",
    "AP4E1",
    "AP4M1",
    "AP4S1",
    "APP",
    "ARCN1",
    "ARFGEF2",
    "ARHGAP31",
    "ARHGEF6",
    "ARID1A",
    "ARID1B",
    "ARL14EP",
    "ARNT2",
    "ARSL",
    "ARVCF",
    "ARX",
    "ASNS",
    "ASPM",
    "ASXL1",
    "ASXL3",
    "ATP1A3",
    "ATP2B3",
    "ATP5F1A",
    "ATP5F1E",
    "ATP6V0A2",
    "ATP7A",
    "ATP8A2",
    "ATPAF1",
    "ATPAF2",
    "ATR",
    "ATRIP",
    "ATRX",
    "AUH",
    "AUTS2",
    "B3GALNT2",
    "B3GLCT",
    "B4GAT1",
    "B9D1",
    "B9D2",
    "BAZ1B",
    "BBOX1",
    "BCAP31",
    "BCKDK",
    "BCOR",
    "BCR",
    "BCS1L",
    "BDNF",
    "BLM",
    "BMP15",
    "BMP4",
    "BMPR1A",
    "BRAT1",
    "BRCA2",
    "BRF1",
    "BRIP1",
    "BTG2",
    "BUB1",
    "BUB1B",
    "BUB3",
    "C2CD3",
    "CACNA1H",
    "CACNG2",
    "CANT1",
    "CARS2",
    "CASK",
    "CC2D1A",
    "CC2D2A",
    "CCDC47",
    "CCDC88A",
    "CD96",
    "CDC6",
    "CDH15",
    "CDH4",
    "CDK11A",
    "CDK5",
    "CDK5RAP2",
    "CDK6",
    "CDKL5",
    "CDON",
    "CDT1",
    "CENPE",
    "CENPF",
    "CENPJ",
    "CEP135",
    "CEP152",
    "CEP290",
    "CEP57",
    "CEP63",
    "CERT1",
    "CHAMP1",
    "CHD2",
    "CHD7",
    "CHKB",
    "CHL1",
    "CHMP1A",
    "CHN1",
    "CHRNA1",
    "CHRNA7",
    "CHRND",
    "CHRNG",
    "CHUK",
    "CIT",
    "CKAP2L",
    "CLCN4",
    "CLIP1",
    "CLIP2",
    "CLP1",
    "CLPB",
    "CLPP",
    "CNNM2",
    "CNTN4",
    "COA5",
    "COA6",
    "COG1",
    "COG2",
    "COG4",
    "COG6",
    "COL25A1",
    "COL4A1",
    "COLEC11",
    "COMT",
    "COQ9",
    "COX15",
    "COX7B",
    "CPLX1",
    "CPT2",
    "CRADD",
    "CRBN",
    "CREBBP",
    "CRIPT",
    "CRIPTO",
    "CRKL",
    "CRPPA",
    "CSNK2A1",
    "CSPP1",
    "CTBP1",
    "CTC1",
    "CTCF",
    "CTNNB1",
    "CTNND2",
    "CTSD",
    "CUL4B",
    "CYB5R3",
    "DAG1",
    "DARS1",
    "DCPS",
    "DCX",
    "DDB2",
    "DDX11",
    "DDX3X",
    "DEAF1",
    "DGCR2",
    "DGCR6",
    "DGCR8",
    "DGUOK",
    "DHCR24",
    "DHCR7",
    "DHFR",
    "DHTKD1",
    "DHX37",
    "DIAPH1",
    "DISP1",
    "DKC1",
    "DLAT",
    "DLD",
    "DLG3",
    "DLL1",
    "DLL3",
    "DLL4",
    "DMD",
    "DNA2",
    "DNM1",
    "DNM1L",
    "DOCK6",
    "DOCK8",
    "DOLK",
    "DONSON",
    "DPAGT1",
    "DPM1",
    "DPM2",
    "DPP6",
    "DPYD",
    "DSTYK",
    "DUSP22",
    "DYM",
    "DYNC1H1",
    "DYRK1A",
    "EDC3",
    "EEF1A2",
    "EFEMP2",
    "EFNB1",
    "EFTUD2",
    "EGF",
    "EHMT1",
    "EIF2AK3",
    "EIF2B1",
    "EIF2B2",
    "EIF2B3",
    "EIF2B4",
    "EIF2B5",
    "ELAC2",
    "ELN",
    "ELOVL4",
    "EMG1",
    "EML1",
    "ENTPD1",
    "EOGT",
    "EOMES",
    "EP300",
    "EPB41L1",
    "EPG5",
    "ERCC1",
    "ERCC2",
    "ERCC3",
    "ERCC4",
    "ERCC5",
    "ERCC6",
    "ERCC6L2",
    "ERCC8",
    "ERMARD",
    "ESCO2",
    "ETFA",
    "EXOSC3",
    "EXOSC8",
    "EXT1",
    "FAM20C",
    "FANCA",
    "FANCB",
    "FANCC",
    "FANCD2",
    "FANCE",
    "FANCF",
    "FANCG",
    "FANCI",
    "FANCL",
    "FANCM",
    "FAR1",
    "FARS2",
    "FBLN5",
    "FBN1",
    "FBXL4",
    "FBXO31",
    "FGF3",
    "FGF8",
    "FGFR1",
    "FGFR3",
    "FGFRL1",
    "FH",
    "FIG4",
    "FKRP",
    "FKTN",
    "FLII",
    "FLNA",
    "FMN2",
    "FOXG1",
    "FOXH1",
    "FRAS1",
    "FREM1",
    "FREM2",
    "FRMD4A",
    "FSHR",
    "FTO",
    "FTSJ1",
    "G6PC3",
    "GABRA1",
    "GABRB2",
    "GABRD",
    "GABRG2",
    "GAD1",
    "GALC",
    "GAS1",
    "GATA1",
    "GATA4",
    "GATA6",
    "GBA1",
    "GDI1",
    "GEMIN4",
    "GFM1",
    "GJA1",
    "GJA5",
    "GJA8",
    "GJB3",
    "GJB4",
    "GLG1",
    "GLI2",
    "GLYCTK",
    "GMPPA",
    "GMPPB",
    "GNAO1",
    "GNPAT",
    "GOLGA2",
    "GORAB",
    "GP1BB",
    "GPT2",
    "GRIK2",
    "GRIN1",
    "GRIN2B",
    "GRIP1",
    "GTF2H5",
    "GTF2I",
    "GTF2IRD1",
    "HARS2",
    "HBA1",
    "HBA2",
    "HCCS",
    "HCFC1",
    "HCN1",
    "HDAC4",
    "HDAC8",
    "HELZ",
    "HES7",
    "HHAT",
    "HIC1",
    "HIRA",
    "HMGA2",
    "HMGB1",
    "HMGB3",
    "HNRNPK",
    "HSD17B4",
    "HSPD1",
    "HSPG2",
    "HUWE1",
    "IBA57",
    "IER3IP1",
    "IFIH1",
    "IFT140",
    "IFT172",
    "IGF1",
    "IGF1R",
    "IGFBP4",
    "IKBKG",
    "IL1RAPL1",
    "INA",
    "INO80",
    "INSR",
    "IQCB1",
    "IQSEC2",
    "ITGA3",
    "ITGB6",
    "JAM3",
    "JMJD1C",
    "KANK1",
    "KANSL1",
    "KARS1",
    "KAT6A",
    "KAT6B",
    "KATNB1",
    "KCNAB2",
    "KCNB1",
    "KCNJ11",
    "KCNJ2",
    "KCNJ5",
    "KCNJ6",
    "KCNQ2",
    "KCNT1",
    "KCTD13",
    "KCTD7",
    "KDM5C",
    "KDM6A",
    "KIF11",
    "KIF14",
    "KIF1A",
    "KIF23",
    "KIF2A",
    "KIF5C",
    "KIFBP",
    "KIRREL3",
    "KIT",
    "KITLG",
    "KMT2A",
    "KMT2D",
    "KNL1",
    "KRAS",
    "L1CAM",
    "LARGE1",
    "LARP7",
    "LARS1",
    "LARS2",
    "LAS1L",
    "LEMD3",
    "LETM1",
    "LFNG",
    "LIAS",
    "LIG4",
    "LIMK1",
    "LINS1",
    "LMNA",
    "LRP5",
    "LTC4S",
    "MAD2L2",
    "MAFB",
    "MAGI2",
    "MAGT1",
    "MAN1B1",
    "MANF",
    "MAOA",
    "MAPK1",
    "MAPRE2",
    "MASP1",
    "MATN4",
    "MBD5",
    "MBTPS2",
    "MCM4",
    "MCOLN1",
    "MCPH1",
    "MCTP2",
    "MECP2",
    "MED12",
    "MED13L",
    "MED17",
    "MED23",
    "MED25",
    "MEF2C",
    "MEIS2",
    "MESP2",
    "METTL23",
    "MFSD2A",
    "MGAT2",
    "MGME1",
    "MID2",
    "MIPEP",
    "MIR17HG",
    "MITF",
    "MKS1",
    "MMACHC",
    "MOCS1",
    "MOCS2",
    "MPC1",
    "MPDU1",
    "MPL",
    "MPLKIP",
    "MRE11",
    "MRPS22",
    "MSMO1",
    "MTFMT",
    "MTHFR",
    "MTSS2",
    "MVK",
    "MXRA8",
    "MYCN",
    "MYH10",
    "MYH3",
    "MYO18B",
    "NAA10",
    "NADK2",
    "NALCN",
    "NANS",
    "NARS2",
    "NAT8L",
    "NBN",
    "NCAPD3",
    "NCAPG2",
    "NDE1",
    "NDP",
    "NDST1",
    "NDUFB11",
    "NECAP1",
    "NEK9",
    "NELFA",
    "NEXMIF",
    "NF1",
    "NGLY1",
    "NHEJ1",
    "NHP2",
    "NIN",
    "NIPBL",
    "NLGN1",
    "NODAL",
    "NOP10",
    "NOTCH1",
    "NPHP1",
    "NPHP3",
    "NPHP4",
    "NR2E1",
    "NR5A1",
    "NRG1",
    "NRXN1",
    "NSD1",
    "NSD2",
    "NSDHL",
    "NSUN2",
    "NTNG1",
    "NUP107",
    "OCLN",
    "OFD1",
    "OGDHL",
    "OPHN1",
    "ORC1",
    "ORC4",
    "ORC6",
    "PAFAH1B1",
    "PAH",
    "PAK3",
    "PALB2",
    "PARN",
    "PAX3",
    "PAX6",
    "PCDH12",
    "PCDH15",
    "PCDH19",
    "PCDHB4",
    "PCLO",
    "PCNA",
    "PCNT",
    "PDGFB",
    "PDGFRB",
    "PDHA1",
    "PDHX",
    "PEX1",
    "PEX10",
    "PEX11B",
    "PEX12",
    "PEX13",
    "PEX14",
    "PEX16",
    "PEX19",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PEX7",
    "PGAP2",
    "PGAP3",
    "PHC1",
    "PHF6",
    "PHGDH",
    "PIAS4",
    "PIEZO2",
    "PIGA",
    "PIGL",
    "PIGN",
    "PIGO",
    "PIGQ",
    "PIGV",
    "PIGW",
    "PIGY",
    "PIK3CB",
    "PLCB1",
    "PLEKHG2",
    "PLK4",
    "PLP1",
    "PMM2",
    "PNKP",
    "PNPO",
    "PNPT1",
    "POC1A",
    "POGZ",
    "POLG",
    "POLR1A",
    "POLR1C",
    "POMGNT1",
    "POMGNT2",
    "POMK",
    "POMT1",
    "POMT2",
    "POR",
    "PORCN",
    "PPP1R15B",
    "PPP2R1A",
    "PPT1",
    "PQBP1",
    "PRDM16",
    "PRKD1",
    "PRKDC",
    "PRSS12",
    "PRUNE1",
    "PSAT1",
    "PSMC3IP",
    "PSPH",
    "PTCH1",
    "PTCHD1",
    "PTDSS1",
    "PTF1A",
    "PTPN11",
    "PTPRT",
    "PTRH2",
    "PTS",
    "PUF60",
    "PUS1",
    "PYCR1",
    "PYCR2",
    "QARS1",
    "QDPR",
    "RAB18",
    "RAB33B",
    "RAB39B",
    "RAB3GAP1",
    "RAB3GAP2",
    "RAD21",
    "RAD50",
    "RAD51",
    "RAD51C",
    "RAI1",
    "RAP1A",
    "RAP1B",
    "RAPSN",
    "RARS1",
    "RARS2",
    "RB1",
    "RBBP8",
    "RBM28",
    "RBPJ",
    "RECQL4",
    "RELN",
    "REN",
    "RERE",
    "RFC2",
    "RFT1",
    "RIPK4",
    "RIPPLY2",
    "RNASEH2A",
    "RNASEH2B",
    "RNASEH2C",
    "RNASET2",
    "RNF113A",
    "RNF168",
    "RPGRIP1",
    "RPGRIP1L",
    "RPL10",
    "RPL11",
    "RPL15",
    "RPL26",
    "RPL35A",
    "RPL5",
    "RPS10",
    "RPS19",
    "RPS24",
    "RPS26",
    "RPS28",
    "RPS29",
    "RPS6KA3",
    "RPS7",
    "RREB1",
    "RRM2B",
    "RSPRY1",
    "RTEL1",
    "RTTN",
    "RXYLT1",
    "SALL1",
    "SAMD9L",
    "SAMHD1",
    "SASS6",
    "SATB2",
    "SBF1",
    "SC5D",
    "SCN1A",
    "SCN1B",
    "SCN2A",
    "SCN8A",
    "SCN9A",
    "SCO1",
    "SCO2",
    "SDCCAG8",
    "SEC24C",
    "SEMA3E",
    "SEMA5A",
    "SEPSECS",
    "SETBP1",
    "SF3B4",
    "SGCA",
    "SGCE",
    "SHANK2",
    "SHANK3",
    "SHH",
    "SIK1",
    "SIL1",
    "SIM1",
    "SIN3A",
    "SIX3",
    "SIX6",
    "SKI",
    "SLC12A5",
    "SLC12A6",
    "SLC13A5",
    "SLC16A2",
    "SLC18A2",
    "SLC19A3",
    "SLC1A4",
    "SLC20A2",
    "SLC25A1",
    "SLC25A19",
    "SLC25A22",
    "SLC2A1",
    "SLC35A2",
    "SLC35A3",
    "SLC35C1",
    "SLC35F5",
    "SLC6A17",
    "SLC6A8",
    "SLC9A6",
    "SLX4",
    "SMAD4",
    "SMARCA1",
    "SMARCA2",
    "SMARCA4",
    "SMARCB1",
    "SMARCE1",
    "SMC1A",
    "SMC3",
    "SNAI2",
    "SNAP29",
    "SNRPB",
    "SOX10",
    "SOX11",
    "SOX2",
    "SOX3",
    "SP110",
    "SPART",
    "SPDL1",
    "SPOCK1",
    "SPR",
    "SPTAN1",
    "SSR4",
    "ST3GAL3",
    "ST3GAL5",
    "STAG2",
    "STAMBP",
    "STIL",
    "STT3A",
    "STT3B",
    "STXBP1",
    "SUCLA2",
    "SUMF1",
    "SV2A",
    "SYNE1",
    "SYNGAP1",
    "SYP",
    "TAF2",
    "TAT",
    "TBC1D20",
    "TBC1D23",
    "TBC1D24",
    "TBCD",
    "TBCE",
    "TBL1XR1",
    "TBL2",
    "TBX1",
    "TBX2",
    "TBX4",
    "TBX6",
    "TCF12",
    "TCF4",
    "TCTN2",
    "TCTN3",
    "TECPR2",
    "TECR",
    "TERT",
    "TFAP2A",
    "TGFBR2",
    "TGIF1",
    "THOC2",
    "THOC6",
    "THPO",
    "TINF2",
    "TMCO1",
    "TMEM165",
    "TMEM216",
    "TMEM231",
    "TMEM67",
    "TMEM70",
    "TMTC3",
    "TNN",
    "TOE1",
    "TOP3A",
    "TP63",
    "TRAF3IP1",
    "TRAIP",
    "TRAPPC11",
    "TRAPPC9",
    "TREX1",
    "TRMT10A",
    "TRNT1",
    "TRPS1",
    "TSEN15",
    "TSEN2",
    "TSEN34",
    "TSEN54",
    "TSPAN7",
    "TSR2",
    "TTC1",
    "TTI1",
    "TTI2",
    "TUBA1A",
    "TUBA3E",
    "TUBA8",
    "TUBB",
    "TUBB2B",
    "TUBB3",
    "TUBB4A",
    "TUBG1",
    "TUBGCP4",
    "TUBGCP6",
    "TUFM",
    "TUSC3",
    "TWIST1",
    "TWNK",
    "UBE2T",
    "UBE3A",
    "UBE3B",
    "UBR1",
    "UFD1",
    "UNC13A",
    "UPB1",
    "UPF3B",
    "USB1",
    "USP9X",
    "VARS1",
    "VARS2",
    "VIPAS39",
    "VPS13B",
    "VPS33B",
    "VPS53",
    "VRK1",
    "WASHC4",
    "WDPCP",
    "WDR19",
    "WDR45",
    "WDR62",
    "WDR73",
    "WRAP53",
    "WT1",
    "WWOX",
    "XIRP1",
    "XPA",
    "XPC",
    "XPR1",
    "XRCC2",
    "XRCC4",
    "XYLT1",
    "YARS2",
    "YWHAE",
    "ZBTB16",
    "ZBTB18",
    "ZC3H14",
    "ZDHHC9",
    "ZEB2",
    "ZIC1",
    "ZIC2",
    "ZNF148",
    "ZNF219",
    "ZNF335",
    "ZNF41",
    "ZNF592",
    "ZNF674",
    "ZNF711",
    "ZNF81"
  ],
  "/test/Muscular Dystrophy Panel": [
    "ACAD9",
    "ACADVL",
    "ACTA1",
    "ANO5",
    "ATP2A1",
    "B3GALNT2",
    "B4GAT1",
    "BAG3",
    "BICD2",
    "BIN1",
    "CAPN3",
    "CASQ1",
    "CAV3",
    "CAVIN1",
    "CFL2",
    "CHKB",
    "CNTN1",
    "COL12A1",
    "COL4A1",
    "COL4A2",
    "COL6A1",
    "COL6A2",
    "COL6A3",
    "COQ2",
    "COQ8A",
    "CRPPA",
    "CRYAB",
    "DAG1",
    "DES",
    "DGUOK",
    "DMD",
    "DNAJB6",
    "DPM1",
    "DPM2",
    "DPM3",
    "DYSF",
    "EMD",
    "FDX2",
    "FHL1",
    "FKRP",
    "FKTN",
    "FLAD1",
    "FLNC",
    "GAA",
    "GBE1",
    "GMPPB",
    "GOLGA2",
    "GOSR2",
    "GYG1",
    "HNRNPDL",
    "INPP5K",
    "ISCU",
    "ITGA7",
    "KBTBD13",
    "KLHL40",
    "KLHL41",
    "LAMA2",
    "LAMP2",
    "LARGE1",
    "LDB3",
    "LIMS2",
    "LMNA",
    "LMOD3",
    "MAP3K20",
    "MEGF10",
    "MICU1",
    "MME",
    "MMEL1",
    "MSTO1",
    "MTM1",
    "MYH7",
    "MYO18B",
    "MYOT",
    "NEB",
    "PGK1",
    "PHKA1",
    "PHKB",
    "PLEC",
    "PNPLA2",
    "POGLUT1",
    "POLG",
    "POLG2",
    "POMGNT1",
    "POMGNT2",
    "POMK",
    "POMT1",
    "POMT2",
    "PYGM",
    "PYROXD1",
    "RBCK1",
    "RRM2B",
    "RXYLT1",
    "RYR1",
    "SCN4A",
    "SELENON",
    "SEPTIN9",
    "SGCA",
    "SGCB",
    "SGCD",
    "SGCG",
    "SIL1",
    "SLC22A5",
    "SLC25A20",
    "SMCHD1",
    "SPEG",
    "SPTBN4",
    "STAC3",
    "SUCLA2",
    "SUCLG1",
    "SYNE1",
    "SYNE2",
    "TANGO2",
    "TCAP",
    "TIA1",
    "TK2",
    "TMEM126B",
    "TMEM43",
    "TNNT1",
    "TNPO3",
    "TOR1AIP1",
    "TPM2",
    "TPM3",
    "TRAPPC11",
    "TRIM32",
    "TSFM",
    "TTN",
    "TYMP",
    "VMA21",
    "VPS13A"
  ],
  "/test/Myopathy Panel": [
    "ACTA1",
    "AGRN",
    "ALG14",
    "ALG2",
    "ANO5",
    "ATP2A1",
    "BAG3",
    "BICD2",
    "BIN1",
    "CACNA1S",
    "CAV3",
    "CCDC78",
    "CFL2",
    "CHAT",
    "CHKB",
    "CHRNA1",
    "CHRNB1",
    "CHRND",
    "CHRNE",
    "CNTN1",
    "COL12A1",
    "COL13A1",
    "COL6A1",
    "COL6A2",
    "COL6A3",
    "COLQ",
    "CRPPA",
    "CRYAB",
    "DES",
    "DNAJB6",
    "DNM2",
    "DOK7",
    "DPAGT1",
    "DYSF",
    "FHL1",
    "FKRP",
    "FKTN",
    "FLNC",
    "GFPT1",
    "GLDN",
    "GNE",
    "ITGA7",
    "KBTBD13",
    "KLHL40",
    "KLHL41",
    "KY",
    "LAMA2",
    "LARGE1",
    "LDB3",
    "LMNA",
    "LMOD3",
    "LRP4",
    "MEGF10",
    "MICU1",
    "MTM1",
    "MTMR14",
    "MUSK",
    "MYF6",
    "MYH2",
    "MYH7",
    "MYL2",
    "MYO18B",
    "MYO9A",
    "MYOT",
    "MYPN",
    "NALCN",
    "NEB",
    "PAX7",
    "POMGNT1",
    "POMT1",
    "POMT2",
    "PREPL",
    "PYROXD1",
    "RAPSN",
    "RYR1",
    "SCN4A",
    "SELENON",
    "SLC18A3",
    "SLC25A1",
    "SLC5A7",
    "SNAP25",
    "SPEG",
    "STAC3",
    "STIM1",
    "SYNE1",
    "SYT2",
    "TBCK",
    "TIA1",
    "TNNT1",
    "TPM2",
    "TPM3",
    "TRIP4",
    "TTN",
    "UNC80",
    "VAMP1",
    "VMA21"
  ],
  "/test/Parkinson\u2019s Disease, Alzheimer\u2019s Disease, and Dementia": [
    "AFG3L2",
    "APOE",
    "APP",
    "ATP13A2",
    "ATP1A3",
    "ATP6AP2",
    "C9orf72",
    "CHCHD10",
    "CHMP2B",
    "CP",
    "CSF1R",
    "DCTN1",
    "DNAJC5",
    "DNAJC6",
    "DNMT1",
    "EIF4G1",
    "FBXO7",
    "FUS",
    "GBA1",
    "GCH1",
    "GRN",
    "HTRA2",
    "ITM2B",
    "LRRK2",
    "MAPT",
    "NOTCH3",
    "PARK7",
    "PINK1",
    "PLA2G6",
    "POLG",
    "PRKN",
    "PRKRA",
    "PRNP",
    "PSEN1",
    "PSEN2",
    "SLC20A2",
    "SLC6A3",
    "SNCA",
    "SNCB",
    "SORL1",
    "SQSTM1",
    "SYNJ1",
    "TAF1",
    "TARDBP",
    "TBK1",
    "TH",
    "TREM2",
    "TYROBP",
    "UBQLN2",
    "UCHL1",
    "VCP",
    "VPS13A",
    "VPS35",
    "XPR1"
  ],
  "/test/Hereditary Cancer": [
    "ABRAXAS1",
    "ACD",
    "AIP",
    "AKT1",
    "ALK",
    "APC",
    "ATM",
    "AXIN2",
    "BAP1",
    "BARD1",
    "BLM",
    "BMPR1A",
    "BRCA1",
    "BRCA2",
    "BRIP1",
    "CASR",
    "CDC73",
    "CDH1",
    "CDK4",
    "CDKN1B",
    "CDKN1C",
    "CDKN2A",
    "CEBPA",
    "CHEK2",
    "CTNNA1",
    "CTRC",
    "DDB2",
    "DICER1",
    "DIS3L2",
    "EGFR",
    "ELAC2",
    "EPCAM",
    "ERCC1",
    "ERCC2",
    "ERCC3",
    "ERCC4",
    "ERCC5",
    "FANCA",
    "FANCB",
    "FANCC",
    "FANCD2",
    "FANCE",
    "FANCF",
    "FANCG",
    "FANCI",
    "FANCL",
    "FH",
    "FLCN",
    "GALNT12",
    "GATA2",
    "GPC3",
    "HOXB13",
    "HRAS",
    "KIF1B",
    "KIT",
    "LZTR1",
    "MAX",
    "MBD4",
    "MEN1",
    "MET",
    "MITF",
    "MLH1",
    "MRAS",
    "MRE11",
    "MSH2",
    "MSH3",
    "MSH6",
    "MUTYH",
    "NBN",
    "NF1",
    "NF2",
    "NSD1",
    "NTHL1",
    "NTRK1",
    "PALB2",
    "PALLD",
    "PDGFRA",
    "PHOX2B",
    "PIK3CA",
    "PMS2",
    "POLD1",
    "POLE",
    "POT1",
    "PRKAR1A",
    "PTCH1",
    "PTEN",
    "RAD50",
    "RAD51",
    "RAD51B",
    "RAD51C",
    "RAD51D",
    "RASSF7",
    "RB1",
    "RECQL4",
    "RET",
    "RHBDF2",
    "RINT1",
    "RUNX1",
    "SDHA",
    "SDHAF2",
    "SDHB",
    "SDHC",
    "SDHD",
    "SLX4",
    "SMAD4",
    "SMARCA4",
    "SMARCB1",
    "SMARCE1",
    "SPINK1",
    "SPRED1",
    "STK11",
    "SUFU",
    "TERC",
    "TERF2IP",
    "TERT",
    "TMEM127",
    "TP53",
    "TSC1",
    "TSC2",
    "VHL",
    "WRN",
    "WT1",
    "XPA",
    "XPC",
    "XRCC2"
  ],
  "/test/Comprehensive Eye Disorders": [
    "ABCA4",
    "ABCB6",
    "ABCC6",
    "ABHD12",
    "ABHD5",
    "ACBD5",
    "ACO2",
    "ACTB",
    "ADAM9",
    "ADAMTS10",
    "ADAMTS18",
    "ADAMTSL4",
    "ADGRA3",
    "ADGRV1",
    "ADIPOR1",
    "AFF4",
    "AGBL1",
    "AGBL5",
    "AGK",
    "AHI1",
    "AHR",
    "AIPL1",
    "ALDH18A1",
    "ALDH1A3",
    "ALMS1",
    "AMACR",
    "ANTXR1",
    "AP1S1",
    "AP3B1",
    "APTX",
    "ARHGEF18",
    "ARL13B",
    "ARL2BP",
    "ARL3",
    "ARL6",
    "ARMC9",
    "ARR3",
    "ARSG",
    "ASB10",
    "ASRGL1",
    "ATF6",
    "ATOH7",
    "AUH",
    "B3GLCT",
    "B9D1",
    "B9D2",
    "BBIP1",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS5",
    "BBS7",
    "BBS9",
    "BCOR",
    "BEST1",
    "BFSP1",
    "BFSP2",
    "BLOC1S3",
    "BLOC1S6",
    "BMP4",
    "BMP7",
    "BUB1B",
    "C12orf57",
    "C1QTNF5",
    "CA4",
    "CABP4",
    "CACNA1F",
    "CACNA2D4",
    "CANT1",
    "CAPN5",
    "CASK",
    "CAV1",
    "CC2D2A",
    "CDH23",
    "CDH3",
    "CDHR1",
    "CENPF",
    "CEP104",
    "CEP120",
    "CEP164",
    "CEP19",
    "CEP250",
    "CEP290",
    "CEP41",
    "CEP78",
    "CEP83",
    "CERKL",
    "CFAP410",
    "CFAP418",
    "CFH",
    "CHD7",
    "CHM",
    "CHMP4B",
    "CHN1",
    "CHRDL1",
    "CHST6",
    "CIB2",
    "CISD2",
    "CLDN19",
    "CLN3",
    "CLN5",
    "CLN6",
    "CLN8",
    "CLPB",
    "CLRN1",
    "CNGA1",
    "CNGA3",
    "CNGB1",
    "CNGB3",
    "CNNM4",
    "COL11A1",
    "COL11A2",
    "COL17A1",
    "COL18A1",
    "COL25A1",
    "COL2A1",
    "COL4A1",
    "COL4A3",
    "COL4A5",
    "COL8A2",
    "COL9A1",
    "COL9A2",
    "COL9A3",
    "CPLANE1",
    "CRB1",
    "CREBBP",
    "CRPPA",
    "CRX",
    "CRYAA",
    "CRYAB",
    "CRYBA1",
    "CRYBA2",
    "CRYBA4",
    "CRYBB1",
    "CRYBB2",
    "CRYBB3",
    "CRYGB",
    "CRYGC",
    "CRYGD",
    "CRYGS",
    "CSPP1",
    "CTC1",
    "CTDP1",
    "CTNNA1",
    "CTNNB1",
    "CTSD",
    "CTSF",
    "CWC27",
    "CYP1B1",
    "CYP27A1",
    "CYP4V2",
    "CYP51A1",
    "DCN",
    "DGUOK",
    "DHCR7",
    "DHDDS",
    "DHX38",
    "DNA2",
    "DNAJC19",
    "DNAJC5",
    "DNM1L",
    "DOCK6",
    "DRAM2",
    "DTHD1",
    "DTNBP1",
    "EARS2",
    "EBP",
    "EDN3",
    "EDNRB",
    "EFEMP1",
    "ELOVL4",
    "ELP4",
    "EMC1",
    "EPG5",
    "EPHA2",
    "ERCC1",
    "ERCC2",
    "ERCC5",
    "ERCC6",
    "ERCC8",
    "ESCO2",
    "EXOSC2",
    "EYA1",
    "EYS",
    "FAM111A",
    "FAM161A",
    "FBN1",
    "FH",
    "FIG4",
    "FLVCR1",
    "FOXC1",
    "FOXE3",
    "FOXL2",
    "FRAS1",
    "FREM1",
    "FREM2",
    "FRMD7",
    "FSCN2",
    "FTL",
    "FYCO1",
    "FZD4",
    "GALK1",
    "GCNT2",
    "GDF3",
    "GDF6",
    "GFER",
    "GJA1",
    "GJA3",
    "GJA8",
    "GJB2",
    "GJB6",
    "GNAT1",
    "GNAT2",
    "GNB3",
    "GNPTG",
    "GP1BA",
    "GPR143",
    "GPR179",
    "GRHL2",
    "GRIP1",
    "GRK1",
    "GRM6",
    "GRN",
    "GSN",
    "GUCA1A",
    "GUCA1B",
    "GUCY2D",
    "HARS1",
    "HCCS",
    "HDAC6",
    "HESX1",
    "HGSNAT",
    "HK1",
    "HMCN1",
    "HMGB3",
    "HMX1",
    "HOXA1",
    "HOXB1",
    "HPS1",
    "HPS3",
    "HPS4",
    "HPS5",
    "HPS6",
    "HSD17B4",
    "HSF4",
    "HSPG2",
    "HYCC1",
    "IARS2",
    "IDH3A",
    "IDH3B",
    "IFT140",
    "IFT172",
    "IFT27",
    "IFT43",
    "IFT74",
    "IFT80",
    "IGBP1",
    "IGFBP7",
    "IMPDH1",
    "IMPG1",
    "IMPG2",
    "INPP5E",
    "IQCB1",
    "ISCA2",
    "ITM2B",
    "JAG1",
    "JAM3",
    "KATNIP",
    "KCNH1",
    "KCNJ13",
    "KCNV2",
    "KCTD7",
    "KERA",
    "KIAA0586",
    "KIAA1549",
    "KIF11",
    "KIF21A",
    "KIF7",
    "KIZ",
    "KLC2",
    "KLHL7",
    "KRT12",
    "KRT3",
    "LAMA1",
    "LCA5",
    "LCAT",
    "LEMD2",
    "LIM2",
    "LMX1B",
    "LONP1",
    "LOXHD1",
    "LOXL1",
    "LRAT",
    "LRIT3",
    "LRMDA",
    "LRP2",
    "LRP5",
    "LRPAP1",
    "LSS",
    "LTBP2",
    "LYST",
    "LZTFL1",
    "MAB21L2",
    "MAF",
    "MAFB",
    "MAK",
    "MAPKAPK3",
    "MC1R",
    "MED25",
    "MERTK",
    "MFF",
    "MFN2",
    "MFRP",
    "MFSD8",
    "MGME1",
    "MIP",
    "MIR184",
    "MITF",
    "MKKS",
    "MKS1",
    "MLPH",
    "MMP19",
    "MSMO1",
    "MTO1",
    "MTPAP",
    "MTRFR",
    "MTTP",
    "MYH2",
    "MYH9",
    "MYO5A",
    "MYO7A",
    "MYOC",
    "NAA10",
    "NARS2",
    "NBAS",
    "NDP",
    "NDUFAF3",
    "NDUFS1",
    "NEK2",
    "NEUROD1",
    "NF2",
    "NHS",
    "NLRP1",
    "NLRP3",
    "NMNAT1",
    "NOD2",
    "NPHP1",
    "NPHP4",
    "NR2E3",
    "NR2F1",
    "NRL",
    "NTF4",
    "NYX",
    "OAT",
    "OCA2",
    "OCRL",
    "OFD1",
    "OPA1",
    "OPA3",
    "OPN1LW",
    "OPN1SW",
    "OPTC",
    "OPTN",
    "OR2W3",
    "OTX2",
    "OVOL2",
    "P3H2",
    "P4HA2",
    "PANK2",
    "PAX2",
    "PAX3",
    "PAX6",
    "PCARE",
    "PCDH15",
    "PCYT1A",
    "PDE6A",
    "PDE6B",
    "PDE6C",
    "PDE6D",
    "PDE6G",
    "PDE6H",
    "PDHX",
    "PDSS1",
    "PDZD7",
    "PEX1",
    "PEX10",
    "PEX11B",
    "PEX12",
    "PEX13",
    "PEX16",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PEX7",
    "PGAP1",
    "PGK1",
    "PHGDH",
    "PHOX2A",
    "PIBF1",
    "PIGL",
    "PIK3R1",
    "PIK3R5",
    "PIKFYVE",
    "PITPNM3",
    "PITX2",
    "PITX3",
    "PLA2G5",
    "PLK4",
    "PNKP",
    "PNPLA6",
    "POC1B",
    "POLG",
    "POLG2",
    "POMGNT1",
    "POMT1",
    "PORCN",
    "PPT1",
    "PQBP1",
    "PRCD",
    "PRDM13",
    "PRDM5",
    "PRIMPOL",
    "PROM1",
    "PRPF3",
    "PRPF31",
    "PRPF4",
    "PRPF6",
    "PRPF8",
    "PRPH2",
    "PRPS1",
    "PRSS56",
    "PTEN",
    "PXDN",
    "RAB18",
    "RAB27A",
    "RAB28",
    "RAB3GAP1",
    "RAB3GAP2",
    "RARB",
    "RAX",
    "RAX2",
    "RB1",
    "RBP3",
    "RBP4",
    "RCBTB1",
    "RD3",
    "RDH11",
    "RDH12",
    "RDH5",
    "RECQL4",
    "REEP6",
    "RERE",
    "RGR",
    "RGS9",
    "RGS9BP",
    "RHO",
    "RIMS1",
    "RLBP1",
    "RNASEH1",
    "ROBO3",
    "ROM1",
    "RP1",
    "RP1L1",
    "RP2",
    "RP9",
    "RPE65",
    "RPGR",
    "RPGRIP1",
    "RPGRIP1L",
    "RRM2B",
    "RS1",
    "RTN4IP1",
    "RYR1",
    "SAG",
    "SALL2",
    "SALL4",
    "SAMD11",
    "SBF2",
    "SC5D",
    "SCO2",
    "SDCCAG8",
    "SEMA3E",
    "SEMA4A",
    "SH3PXD2B",
    "SHH",
    "SIL1",
    "SIPAL3",
    "SIX6",
    "SLC16A12",
    "SLC19A2",
    "SLC19A3",
    "SLC24A1",
    "SLC24A5",
    "SLC25A4",
    "SLC25A46",
    "SLC33A1",
    "SLC38A8",
    "SLC39A5",
    "SLC45A2",
    "SLC4A11",
    "SLC4A4",
    "SLC7A14",
    "SLITRK6",
    "SMOC1",
    "SNAI2",
    "SNRNP200",
    "SOX10",
    "SOX2",
    "SOX5",
    "SPATA7",
    "SPECC1L",
    "SPG7",
    "SPP2",
    "SPRTN",
    "SRD5A3",
    "STRA6",
    "SUCLA2",
    "SUFU",
    "TACO1",
    "TACSTD2",
    "TBC1D20",
    "TBC1D24",
    "TBK1",
    "TBX22",
    "TCTN1",
    "TCTN2",
    "TCTN3",
    "TDRD7",
    "TEAD1",
    "TENM3",
    "TFAP2A",
    "TGFBI",
    "TIMM8A",
    "TIMP3",
    "TK2",
    "TMEM107",
    "TMEM126A",
    "TMEM138",
    "TMEM216",
    "TMEM231",
    "TMEM237",
    "TMEM67",
    "TMEM98",
    "TOP3A",
    "TOPORS",
    "TPP1",
    "TRAF3IP1",
    "TREX1",
    "TRIM32",
    "TRIM44",
    "TRNT1",
    "TRPM1",
    "TSFM",
    "TSPAN12",
    "TTC21B",
    "TTC8",
    "TTLL5",
    "TTPA",
    "TTR",
    "TUB",
    "TUBA8",
    "TUBB3",
    "TUBGCP4",
    "TUBGCP6",
    "TULP1",
    "TWIST2",
    "TWNK",
    "TYMP",
    "TYR",
    "UBIAD1",
    "UCHL1",
    "UNC119",
    "UNC45B",
    "USH1C",
    "USH1G",
    "USH2A",
    "VAX1",
    "VCAN",
    "VIM",
    "VPS13B",
    "VSX1",
    "VSX2",
    "WDPCP",
    "WDR19",
    "WDR36",
    "WDR73",
    "WFS1",
    "WHRN",
    "WNT3",
    "WRN",
    "XK",
    "XYLT2",
    "YAP1",
    "YME1L1",
    "ZBTB20",
    "ZEB1",
    "ZNF408",
    "ZNF423",
    "ZNF469",
    "ZNF513",
    "ZNF644"
  ],
  "/test/Pharmacogenomic Panel": [
    "ABCG2",
    "APOE",
    "CACNA1S",
    "CES1",
    "CYP2B6",
    "CYP2C19",
    "CYP2C9",
    "CYP2D6",
    "CYP3A4",
    "CYP3A5",
    "CYP4F2",
    "DPYD",
    "F2",
    "F5",
    "IFNL3",
    "IFNL4",
    "MTHFR",
    "NUDT15",
    "RYR1",
    "SLCO1B1",
    "TPMT",
    "VKORC1"
  ],
  "/test/Comprehensive Ciliopathy": [
    "ACVR2B",
    "AHI1",
    "ANKS6",
    "ARL13B",
    "ARL6",
    "ARMC9",
    "B9D1",
    "B9D2",
    "BBIP1",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS5",
    "BBS7",
    "BBS9",
    "C2CD3",
    "CC2D2A",
    "DNAAF19",
    "CCDC39",
    "CCDC40",
    "DRC2",
    "CCNO",
    "CENPF",
    "CEP104",
    "CEP120",
    "CEP164",
    "CEP290",
    "CEP41",
    "CEP83",
    "CFAP298",
    "CFAP300",
    "CFAP418",
    "CFAP53",
    "CFTR",
    "CPLANE1",
    "CSPP1",
    "DCDC2",
    "DNAAF1",
    "DNAAF11",
    "DNAAF2",
    "DNAAF3",
    "DNAAF4",
    "DNAAF5",
    "DNAAF6",
    "DNAH1",
    "DNAH11",
    "DNAH5",
    "DNAH8",
    "DNAH9",
    "DNAI1",
    "DNAI2",
    "DNAJB13",
    "DNAL1",
    "DRC1",
    "FAM149B1",
    "FOXJ1",
    "GAS2L2",
    "GAS8",
    "GDF1",
    "GLIS2",
    "HYDIN",
    "IFT172",
    "IFT27",
    "IFT74",
    "INPP5E",
    "INVS",
    "IQCB1",
    "KATNIP",
    "KIAA0586",
    "KIF14",
    "KIF7",
    "LEFTY2",
    "LRRC56",
    "LZTFL1",
    "MCIDAS",
    "MKKS",
    "MKS1",
    "MMP21",
    "NEK8",
    "NKX2-5",
    "NME8",
    "NODAL",
    "NPHP1",
    "NPHP3",
    "NPHP4",
    "ODAD1",
    "ODAD2",
    "ODAD3",
    "ODAD4",
    "OFD1",
    "PDE6D",
    "PIBF1",
    "PKD1",
    "PKD1L1",
    "PKD2",
    "PKHD1",
    "RPGR",
    "RPGRIP1L",
    "RSPH1",
    "RSPH3",
    "RSPH4A",
    "RSPH9",
    "SDCCAG8",
    "SMAD2",
    "SPAG1",
    "STK36",
    "SUFU",
    "TCTN1",
    "TCTN2",
    "TCTN3",
    "TMEM107",
    "TMEM138",
    "TMEM216",
    "TMEM231",
    "TMEM237",
    "TMEM67",
    "TRIM32",
    "TTC12",
    "TTC21B",
    "TTC8",
    "TXNDC15",
    "WDPCP",
    "WDR19",
    "ZIC3",
    "ZMYND10",
    "ZNF423"
  ],
  "/test/Heterotaxy": [
    "ACVR2B",
    "ANKS6",
    "DNAAF19",
    "CCDC39",
    "CCDC40",
    "CFAP298",
    "CFAP300",
    "CFAP53",
    "DNAAF1",
    "DNAAF11",
    "DNAAF2",
    "DNAAF3",
    "DNAAF4",
    "DNAAF5",
    "DNAAF6",
    "DNAH11",
    "DNAH5",
    "DNAH6",
    "DNAH9",
    "DNAI1",
    "DNAI2",
    "DNAL1",
    "FOXJ1",
    "GAS2L2",
    "GAS8",
    "GDF1",
    "INVS",
    "LEFTY2",
    "LRRC56",
    "MMP21",
    "NKX2-5",
    "NME8",
    "NODAL",
    "ODAD1",
    "ODAD2",
    "ODAD3",
    "ODAD4",
    "PITRM1",
    "PKD1L1",
    "SMAD2",
    "SPAG1",
    "TTC12",
    "ZIC3",
    "ZMYND10"
  ],
  "/test/Interstitial Lung Disease": [
    "ABCA3",
    "CFTR",
    "CSF2RA",
    "CSF2RB",
    "DKC1",
    "FAM111B",
    "FLCN",
    "FOXF1",
    "HPS1",
    "HPS4",
    "ITGA3",
    "NAF1",
    "NKX2-1",
    "PARN",
    "RTEL1",
    "SFTPA1",
    "SFTPA2",
    "SFTPB",
    "SFTPC",
    "SFTPD",
    "SLC34A2",
    "SLC7A7",
    "SMPD1",
    "STAT3",
    "STING1",
    "TERC",
    "TERT",
    "TINF2",
    "TSC1",
    "TSC2"
  ],
  "/test/Primary Ciliary Dyskinesia Panel": [
    "CCDC39",
    "CCDC40",
    "CCNO",
    "CENPF",
    "CFAP298",
    "CFAP300",
    "CFTR",
    "DNAAF1",
    "DNAAF11",
    "DNAAF19",
    "DNAAF2",
    "DNAAF3",
    "DNAAF4",
    "DNAAF5",
    "DNAAF6",
    "DNAH1",
    "DNAH11",
    "DNAH5",
    "DNAH8",
    "DNAH9",
    "DNAI1",
    "DNAI2",
    "DNAJB13",
    "DNAL1",
    "DRC1",
    "FOXJ1",
    "GAS2L2",
    "GAS8",
    "HYDIN",
    "INVS",
    "LRRC56",
    "MCIDAS",
    "NME8",
    "ODAD1",
    "ODAD2",
    "ODAD3",
    "ODAD4",
    "OFD1",
    "RPGR",
    "RSPH1",
    "RSPH3",
    "RSPH4A",
    "RSPH9",
    "SPAG1",
    "STK36",
    "TTC12",
    "ZMYND10",
    "DRC2",
    "KIF14"
  ],
  "/test/Osteogenesis Imperfecta": [
    "ALPL",
    "ARCN1",
    "B3GAT3",
    "B4GALT7",
    "BMP1",
    "CLCN5",
    "COL1A1",
    "COL1A2",
    "CREB3L1",
    "CRTAP",
    "FGF23",
    "FKBP10",
    "IFITM5",
    "LRP5",
    "MBTPS2",
    "NBAS",
    "NTRK1",
    "P3H1",
    "P4HB",
    "PHEX",
    "PLOD2",
    "PLS3",
    "PPIB",
    "SEC24D",
    "SERPINF1",
    "SERPINH1",
    "SGMS2",
    "SLC29A3",
    "SLC2A2",
    "SLC34A3",
    "SP7",
    "SPARC",
    "TAPT1",
    "TENT5A",
    "TMEM38B",
    "WNT1",
    "XYLT2"
  ],
  "/test/Skeletal Dysplasia": [
    "ACAN",
    "ACP5",
    "AGPS",
    "ALPL",
    "ANKH",
    "ANO5",
    "ARHGAP31",
    "ARSL",
    "ATP6V0A2",
    "B3GALT6",
    "B3GAT3",
    "B4GALT7",
    "BMP1",
    "BMP2",
    "BMPR1B",
    "CA2",
    "CANT1",
    "CASR",
    "CC2D2A",
    "CCN6",
    "CDKN1C",
    "CEP290",
    "CHST14",
    "CHST3",
    "CHSY1",
    "CILK1",
    "CLCN5",
    "CLCN7",
    "COL10A1",
    "COL11A1",
    "COL11A2",
    "COL1A1",
    "COL1A2",
    "COL2A1",
    "COL9A1",
    "COL9A2",
    "COL9A3",
    "COMP",
    "CRTAP",
    "CTSK",
    "CUL7",
    "DDR2",
    "DHCR24",
    "DLL3",
    "DLX3",
    "DMP1",
    "DYM",
    "DYNC2H1",
    "EBP",
    "EIF2AK3",
    "ENPP1",
    "ESCO2",
    "EVC",
    "EVC2",
    "EXT1",
    "EXT2",
    "FAM20C",
    "FBLN1",
    "FBN1",
    "FBXW4",
    "FERMT3",
    "FGF10",
    "FGF23",
    "FGFR1",
    "FGFR2",
    "FGFR3",
    "FKBP10",
    "FLNA",
    "FLNB",
    "GALNT3",
    "GDF5",
    "GLI3",
    "GNAS",
    "GNPAT",
    "GORAB",
    "GPC6",
    "GREM1",
    "HDAC4",
    "HES7",
    "HPGD",
    "HSPG2",
    "IFITM5",
    "IFT122",
    "IFT140",
    "IFT80",
    "IHH",
    "KIF22",
    "KIF7",
    "LEMD3",
    "LFNG",
    "LIFR",
    "LMBR1",
    "LMNA",
    "LRP4",
    "LRP5",
    "MAFB",
    "MATN3",
    "MESP2",
    "MGP",
    "MKS1",
    "MMP13",
    "MMP2",
    "MMP9",
    "MYCN",
    "NEK1",
    "NIPBL",
    "NKX3-2",
    "NOG",
    "NOTCH2",
    "NPR2",
    "OBSL1",
    "OSTM1",
    "P3H1",
    "PAPSS2",
    "PCNT",
    "PDE4D",
    "PEX7",
    "PHEX",
    "PIGV",
    "PITX1",
    "PLOD2",
    "PPIB",
    "PPP3CA",
    "PRKAR1A",
    "PTH1R",
    "PTHLH",
    "PTPN11",
    "PYCR1",
    "RECQL4",
    "ROR2",
    "RPGRIP1L",
    "RUNX2",
    "SALL1",
    "SALL4",
    "SERPINF1",
    "SERPINH1",
    "SH3PXD2B",
    "SHH",
    "SHOX",
    "SLC26A2",
    "SLC34A3",
    "SLC35D1",
    "SLC39A13",
    "SMAD4",
    "SMARCAL1",
    "SOST",
    "SOX9",
    "SP7",
    "TBCE",
    "TBX15",
    "TBX3",
    "TBX5",
    "TBX6",
    "TBXAS1",
    "TCIRG1",
    "TGFB1",
    "THPO",
    "TMEM216",
    "TMEM67",
    "TNFRSF11A",
    "TNFRSF11B",
    "TNFSF11",
    "TP63",
    "TREM2",
    "TRIP11",
    "TRPS1",
    "TRPV4",
    "TYROBP",
    "WDR35",
    "WNT3",
    "WNT5A",
    "WNT7A",
    "ZMPSTE24"
  ],
  "/test/Repeat Expansion Disorders": [
    "AAAS",
    "AARS1",
    "AARS2",
    "AASS",
    "ABCA1",
    "ABCA2",
    "ABCA7",
    "ABCB7",
    "ABCC8",
    "ABCD1",
    "ABCD3",
    "ABHD12",
    "ABHD5",
    "ACAD9",
    "ACADM",
    "ACADS",
    "ACADVL",
    "ACAT2",
    "ACBD5",
    "ACO2",
    "ACOX1",
    "ACOX2",
    "ACP5",
    "ACTA1",
    "ACTB",
    "ACTL6B",
    "ACTN2",
    "ADA2",
    "ADAMTS13",
    "ADAR",
    "ADCY5",
    "ADCY6",
    "ADD3",
    "ADGRG1",
    "ADH1C",
    "ADPRS",
    "ADSL",
    "ADSS1",
    "AFF2",
    "AFG3L2",
    "AGA",
    "AGK",
    "AGL",
    "AGRN",
    "AGTPBP1",
    "AHCY",
    "AHI1",
    "AIFM1",
    "AIMP1",
    "ALAD",
    "ALDH18A1",
    "ALDH3A2",
    "ALDH5A1",
    "ALDH6A1",
    "ALG14",
    "ALG2",
    "ALG6",
    "ALS2",
    "AMACR",
    "AMPD2",
    "ANG",
    "ANK3",
    "ANKLE2",
    "ANO10",
    "ANO3",
    "ANO5",
    "ANOS1",
    "AP1S2",
    "AP3B2",
    "AP3D1",
    "AP4B1",
    "AP4E1",
    "AP4M1",
    "AP4S1",
    "AP5Z1",
    "APOB",
    "APP",
    "APTX",
    "AR",
    "ARCN1",
    "ARFGEF2",
    "ARG1",
    "ARL13B",
    "ARL6",
    "ARL6IP1",
    "ARMC9",
    "ARNT2",
    "ARSA",
    "ARV1",
    "ARX",
    "ASAH1",
    "ASCC1",
    "ASCC3",
    "ASL",
    "ASNS",
    "ASS1",
    "ATCAY",
    "ATG5",
    "ATL1",
    "ATM",
    "ATN1",
    "ATP13A2",
    "ATP1A2",
    "ATP1A3",
    "ATP2A1",
    "ATP2B3",
    "ATP5F1E",
    "ATP6AP2",
    "ATP7A",
    "ATP7B",
    "ATP8A2",
    "ATPAF2",
    "ATRX",
    "ATXN1",
    "ATXN10",
    "ATXN2",
    "ATXN3",
    "ATXN7",
    "ATXN8",
    "ATXN8OS",
    "AUH",
    "B3GALNT2",
    "B3GALT6",
    "B4GALNT1",
    "B4GAT1",
    "B9D1",
    "BAG3",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS5",
    "BBS7",
    "BBS9",
    "BCAP31",
    "BCKDHA",
    "BCKDHB",
    "BCL11B",
    "BCOR",
    "BCS1L",
    "BEAN1",
    "BICD2",
    "BIN1",
    "BOLA3",
    "BRAT1",
    "BSCL2",
    "BTD",
    "C19orf12",
    "C1QBP",
    "C9orf72",
    "CA8",
    "CACNA1A",
    "CACNA1B",
    "CACNA1D",
    "CACNA1G",
    "CACNA1S",
    "CACNA2D2",
    "CACNB4",
    "CAMTA1",
    "CAPN1",
    "CAPN3",
    "CARS2",
    "CASK",
    "CASQ1",
    "CAV1",
    "CAV3",
    "CAVIN1",
    "CC2D2A",
    "CCDC28B",
    "CCDC78",
    "CCDC88C",
    "CCT5",
    "CDKL5",
    "CEP104",
    "CEP120",
    "CEP152",
    "CEP290",
    "CEP41",
    "CFH",
    "CFL2",
    "CHAMP1",
    "CHAT",
    "CHCHD10",
    "CHKB",
    "CHMP1A",
    "CHMP2B",
    "CHP1",
    "CHRNA1",
    "CHRNB1",
    "CHRND",
    "CHRNE",
    "CHRNG",
    "CHST14",
    "CIT",
    "CKAP2L",
    "CLCN1",
    "CLCN2",
    "CLN3",
    "CLN5",
    "CLN6",
    "CLN8",
    "CLP1",
    "CLPB",
    "CLPP",
    "CLTC",
    "CNBP",
    "CNTN1",
    "CNTN2",
    "CNTNAP1",
    "CNTNAP2",
    "COA3",
    "COA7",
    "COA8",
    "COASY",
    "COG2",
    "COG4",
    "COG5",
    "COL12A1",
    "COL13A1",
    "COL18A1",
    "COL25A1",
    "COL4A1",
    "COL4A2",
    "COL6A1",
    "COL6A2",
    "COL6A3",
    "COLQ",
    "COQ2",
    "COQ4",
    "COQ5",
    "COQ6",
    "COQ7",
    "COQ8A",
    "COQ9",
    "COX10",
    "COX14",
    "COX15",
    "COX20",
    "COX6B1",
    "COX8A",
    "COXFA4",
    "CP",
    "CPLANE1",
    "CPS1",
    "CPT1C",
    "CPT2",
    "CREBBP",
    "CRLF1",
    "CRPPA",
    "CRYAB",
    "CSF1R",
    "CSPP1",
    "CSTB",
    "CTBP1",
    "CTC1",
    "CTDP1",
    "CTNNB1",
    "CTSD",
    "CTSF",
    "CUL4B",
    "CWF19L1",
    "CYB5R3",
    "CYC1",
    "CYP27A1",
    "CYP2U1",
    "CYP7B1",
    "DAB1",
    "DAG1",
    "DARS1",
    "DARS2",
    "DBT",
    "DCAF17",
    "DCC",
    "DCPS",
    "DCTN1",
    "DCX",
    "DDC",
    "DDHD1",
    "DDHD2",
    "DDX3X",
    "DEAF1",
    "DES",
    "DHCR24",
    "DHFR",
    "DHPS",
    "DIP2B",
    "DKC1",
    "DLAT",
    "DLD",
    "DMD",
    "DMPK",
    "DMXL2",
    "DNA2",
    "DNAJB2",
    "DNAJB4",
    "DNAJB6",
    "DNAJC12",
    "DNAJC19",
    "DNAJC3",
    "DNAJC5",
    "DNAJC6",
    "DNM1L",
    "DNM2",
    "DNMT1",
    "DOCK3",
    "DOCK8",
    "DOK7",
    "DOLK",
    "DPAGT1",
    "DPM1",
    "DPM2",
    "DPM3",
    "DPYD",
    "DPYS",
    "DRD3",
    "DRD5",
    "DTNA",
    "DYNC1H1",
    "DYRK1A",
    "DYSF",
    "EARS2",
    "EBF3",
    "ECEL1",
    "ECHS1",
    "EEF2",
    "EGR2",
    "EIF2B1",
    "EIF2B2",
    "EIF2B3",
    "EIF2B4",
    "EIF2B5",
    "EIF4A3",
    "EIF4G1",
    "ELOVL1",
    "ELOVL4",
    "ELOVL5",
    "ELP2",
    "EMC1",
    "EMD",
    "EML1",
    "ENO3",
    "ENTPD1",
    "EPG5",
    "EPM2A",
    "ERAL1",
    "ERBB4",
    "ERCC1",
    "ERCC2",
    "ERCC3",
    "ERCC4",
    "ERCC5",
    "ERCC6",
    "ERCC8",
    "ERLIN1",
    "ERLIN2",
    "ETFA",
    "ETFB",
    "ETFDH",
    "ETHE1",
    "EXOSC3",
    "EXOSC8",
    "EXOSC9",
    "EXT2",
    "EZH2",
    "FA2H",
    "FAR1",
    "FARS2",
    "FASTKD2",
    "FAT2",
    "FBXL4",
    "FBXO38",
    "FBXO7",
    "FDX2",
    "FERRY3",
    "FGD4",
    "FGF12",
    "FGF14",
    "FGFR1",
    "FHL1",
    "FIG4",
    "FITM2",
    "FKBP14",
    "FKRP",
    "FKTN",
    "FLAD1",
    "FLNA",
    "FLNC",
    "FLVCR1",
    "FMR1",
    "FOLR1",
    "FOXG1",
    "FOXL2",
    "FOXRED1",
    "FRMD4A",
    "FRRS1L",
    "FTL",
    "FUCA1",
    "FUS",
    "FXN",
    "FXR1",
    "GAA",
    "GABRB1",
    "GABRB2",
    "GABRB3",
    "GAD1",
    "GALC",
    "GAMT",
    "GAN",
    "GATAD2B",
    "GBA1",
    "GBA2",
    "GBE1",
    "GCDH",
    "GCH1",
    "GCLC",
    "GDAP2",
    "GEMIN4",
    "GFAP",
    "GFER",
    "GFM1",
    "GFM2",
    "GFPT1",
    "GGPS1",
    "GIGYF2",
    "GIPC1",
    "GJA1",
    "GJC2",
    "GLB1",
    "GLDN",
    "GLE1",
    "GLRA1",
    "GLRX5",
    "GLS",
    "GLYCTK",
    "GM2A",
    "GMPPA",
    "GMPPB",
    "GNAL",
    "GNAO1",
    "GNB4",
    "GNE",
    "GOLGA2",
    "GOSR2",
    "GPAA1",
    "GPR88",
    "GRIA3",
    "GRID2",
    "GRIK2",
    "GRIN1",
    "GRIN2B",
    "GRIN2D",
    "GRM1",
    "GRN",
    "GSS",
    "GYG1",
    "GYS1",
    "HACD1",
    "HACE1",
    "HADHA",
    "HADHB",
    "HARS2",
    "HCFC1",
    "HCN1",
    "HEPACAM",
    "HERC1",
    "HEXA",
    "HEXB",
    "HIBCH",
    "HIKESHI",
    "HK1",
    "HMBS",
    "HMGCR",
    "HNRNPA1",
    "HNRNPA2B1",
    "HNRNPDL",
    "HNRNPH2",
    "HOXA13",
    "HOXD13",
    "HPCA",
    "HPDL",
    "HPRT1",
    "HSD17B10",
    "HSD17B4",
    "HSPB1",
    "HSPB8",
    "HSPD1",
    "HSPG2",
    "HTRA1",
    "HTRA2",
    "HTT",
    "IBA57",
    "IFIH1",
    "IFT140",
    "IFT172",
    "IFT27",
    "IGHMBP2",
    "INPP5E",
    "INPP5K",
    "INTS8",
    "IRF2BPL",
    "ISCA2",
    "ISCU",
    "ITGA7",
    "ITM2B",
    "ITPR1",
    "JAG2",
    "JAM3",
    "JPH3",
    "KANK1",
    "KARS1",
    "KATNIP",
    "KBTBD13",
    "KCNA1",
    "KCNA2",
    "KCNA4",
    "KCNC1",
    "KCNC3",
    "KCND3",
    "KCNJ10",
    "KCNJ6",
    "KCNMA1",
    "KCNQ2",
    "KCNT1",
    "KCTD17",
    "KCTD7",
    "KDM5C",
    "KIAA0586",
    "KIDINS220",
    "KIF1A",
    "KIF1B",
    "KIF1C",
    "KIF2A",
    "KIF5A",
    "KIF5C",
    "KIF7",
    "KLC2",
    "KLHL40",
    "KLHL41",
    "KMT2B",
    "KY",
    "L1CAM",
    "L2HGDH",
    "LAGE3",
    "LAMA2",
    "LAMB2",
    "LAMP2",
    "LARGE1",
    "LDB3",
    "LDHA",
    "LETM1",
    "LGI4",
    "LIAS",
    "LIMS2",
    "LIPT1",
    "LIPT2",
    "LMNA",
    "LMNB1",
    "LMNB2",
    "LMOD3",
    "LPIN1",
    "LRP12",
    "LRP4",
    "LRPPRC",
    "LRRK2",
    "LRSAM1",
    "LYRM7",
    "LYST",
    "MAG",
    "MAN2B1",
    "MAP3K20",
    "MAPT",
    "MARS1",
    "MARS2",
    "MAT1A",
    "MATR3",
    "MB",
    "MBD5",
    "MCCC2",
    "MCOLN1",
    "MDH2",
    "MECP2",
    "MECR",
    "MED13L",
    "MED17",
    "MED25",
    "MEGF10",
    "MFF",
    "MFN2",
    "MFSD2A",
    "MFSD8",
    "MGME1",
    "MICU1",
    "MIPEP",
    "MKS1",
    "MLC1",
    "MLIP",
    "MMACHC",
    "MMADHC",
    "MME",
    "MOCS1",
    "MOCS2",
    "MORC2",
    "MPDU1",
    "MPV17",
    "MPZ",
    "MRE11",
    "MRPS22",
    "MRPS34",
    "MTM1",
    "MTMR14",
    "MTO1",
    "MTPAP",
    "MTRFR",
    "MTTP",
    "MUSK",
    "MVK",
    "MYBPC1",
    "MYH14",
    "MYH2",
    "MYH3",
    "MYH7",
    "MYL1",
    "MYL2",
    "MYMK",
    "MYO18B",
    "MYO7A",
    "MYO9A",
    "MYOD1",
    "MYOT",
    "MYPN",
    "NADK2",
    "NAGA",
    "NAGLU",
    "NALCN",
    "NANS",
    "NAT8L",
    "NAXE",
    "NDE1",
    "NDRG1",
    "NDUFA1",
    "NDUFA10",
    "NDUFA11",
    "NDUFA12",
    "NDUFA13",
    "NDUFA2",
    "NDUFA9",
    "NDUFAF1",
    "NDUFAF2",
    "NDUFAF3",
    "NDUFAF4",
    "NDUFAF5",
    "NDUFAF6",
    "NDUFB3",
    "NDUFB9",
    "NDUFS1",
    "NDUFS2",
    "NDUFS3",
    "NDUFS4",
    "NDUFS6",
    "NDUFS7",
    "NDUFS8",
    "NDUFV1",
    "NDUFV2",
    "NEB",
    "NECAP1",
    "NEFH",
    "NEFL",
    "NEU1",
    "NEXMIF",
    "NF1",
    "NF2",
    "NFASC",
    "NGLY1",
    "NHLRC1",
    "NIPA1",
    "NKX2-1",
    "NKX6-2",
    "NMNAT1",
    "NOL3",
    "NOP56",
    "NOTCH2NLC",
    "NOTCH3",
    "NPC1",
    "NPC2",
    "NPHP1",
    "NR4A2",
    "NSUN2",
    "NT5C2",
    "NUBPL",
    "NUP62",
    "NUTM2B-AS1",
    "OCLN",
    "OFD1",
    "OPA1",
    "OPA3",
    "OPHN1",
    "OPTN",
    "ORAI1",
    "OSGEP",
    "OTC",
    "PABPN1",
    "PAFAH1B1",
    "PANK2",
    "PARK7",
    "PARN",
    "PARS2",
    "PAX7",
    "PC",
    "PCCA",
    "PCCB",
    "PCDH12",
    "PCDH19",
    "PCLO",
    "PCNA",
    "PDE10A",
    "PDE6D",
    "PDE8B",
    "PDGFB",
    "PDGFRB",
    "PDHA1",
    "PDHB",
    "PDHX",
    "PDP1",
    "PDSS1",
    "PDSS2",
    "PDYN",
    "PET100",
    "PEX1",
    "PEX10",
    "PEX11B",
    "PEX12",
    "PEX13",
    "PEX14",
    "PEX16",
    "PEX19",
    "PEX2",
    "PEX26",
    "PEX3",
    "PEX5",
    "PEX6",
    "PEX7",
    "PFKM",
    "PFN1",
    "PGAM2",
    "PGAP1",
    "PGK1",
    "PGM1",
    "PGM3",
    "PHGDH",
    "PHKA1",
    "PHKB",
    "PHOX2B",
    "PHYH",
    "PIBF1",
    "PIEZO2",
    "PIGA",
    "PIGG",
    "PIGN",
    "PIGQ",
    "PIGS",
    "PIK3R5",
    "PINK1",
    "PITRM1",
    "PLA2G6",
    "PLAA",
    "PLCB1",
    "PLD3",
    "PLEC",
    "PLEKHG2",
    "PLEKHG5",
    "PLP1",
    "PLXND1",
    "PMM2",
    "PMP22",
    "PMPCA",
    "PNKD",
    "PNKP",
    "PNP",
    "PNPLA2",
    "PNPLA6",
    "PNPLA8",
    "PNPT1",
    "POGLUT1",
    "POLG",
    "POLG2",
    "POLR1C",
    "POLR3A",
    "POLR3B",
    "POMGNT1",
    "POMGNT2",
    "POMK",
    "POMT1",
    "POMT2",
    "POPDC1",
    "POPDC3",
    "PPP1R15B",
    "PPP2R2B",
    "PPP3CA",
    "PPT1",
    "PQBP1",
    "PRDM12",
    "PRDM8",
    "PREPL",
    "PRF1",
    "PRICKLE1",
    "PRKCG",
    "PRKN",
    "PRKRA",
    "PROK2",
    "PROKR2",
    "PRPH",
    "PRPS1",
    "PRRT2",
    "PRX",
    "PSAP",
    "PSAT1",
    "PSEN1",
    "PSEN2",
    "PSMB8",
    "PTEN",
    "PTF1A",
    "PTPN23",
    "PTRH2",
    "PTRHD1",
    "PTS",
    "PUM1",
    "PURA",
    "PUS1",
    "PYCR2",
    "PYGM",
    "PYROXD1",
    "QARS1",
    "QDPR",
    "RAB18",
    "RAB27A",
    "RAB39B",
    "RAB3GAP1",
    "RAD50",
    "RAPGEF2",
    "RAPSN",
    "RARS1",
    "RARS2",
    "RBCK1",
    "REEP1",
    "REEP2",
    "RETREG1",
    "RFC1",
    "RFT1",
    "RHOBTB2",
    "RLIM",
    "RNASEH1",
    "RNASEH2A",
    "RNASEH2B",
    "RNASEH2C",
    "RNASET2",
    "RNF113A",
    "RNF125",
    "RNF168",
    "RNF170",
    "RNF216",
    "ROGDI",
    "RORA",
    "RPGRIP1L",
    "RPIA",
    "RPL10",
    "RRM2B",
    "RTN2",
    "RTN4IP1",
    "RTTN",
    "RUBCN",
    "RXYLT1",
    "RYR1",
    "RYR3",
    "SACS",
    "SAMD12",
    "SAMD9L",
    "SAMHD1",
    "SARS1",
    "SCARB2",
    "SCN1A",
    "SCN1B",
    "SCN2A",
    "SCN4A",
    "SCN8A",
    "SCN9A",
    "SCO1",
    "SCO2",
    "SCP2",
    "SCYL1",
    "SDHA",
    "SDHAF1",
    "SDHB",
    "SDHD",
    "SELENOI",
    "SELENON",
    "SEPSECS",
    "SERAC1",
    "SETX",
    "SFXN4",
    "SGCA",
    "SGCB",
    "SGCD",
    "SGCE",
    "SGCG",
    "SGPL1",
    "SH3TC2",
    "SHMT2",
    "SIGMAR1",
    "SIL1",
    "SLC12A6",
    "SLC13A5",
    "SLC16A2",
    "SLC17A5",
    "SLC18A2",
    "SLC18A3",
    "SLC19A2",
    "SLC19A3",
    "SLC1A3",
    "SLC1A4",
    "SLC20A2",
    "SLC22A5",
    "SLC25A1",
    "SLC25A12",
    "SLC25A15",
    "SLC25A20",
    "SLC25A22",
    "SLC25A3",
    "SLC25A4",
    "SLC25A42",
    "SLC25A46",
    "SLC2A1",
    "SLC30A10",
    "SLC30A9",
    "SLC33A1",
    "SLC39A14",
    "SLC39A4",
    "SLC44A1",
    "SLC46A1",
    "SLC52A2",
    "SLC52A3",
    "SLC5A7",
    "SLC6A1",
    "SLC6A17",
    "SLC6A19",
    "SLC6A3",
    "SLC6A8",
    "SLC9A1",
    "SLC9A6",
    "SMAD4",
    "SMC1A",
    "SMCHD1",
    "SMG9",
    "SMPD1",
    "SMPX",
    "SNAP25",
    "SNCA",
    "SNORD118",
    "SNX14",
    "SOD1",
    "SOX10",
    "SOX2",
    "SOX3",
    "SOX6",
    "SPART",
    "SPAST",
    "SPEG",
    "SPG11",
    "SPG21",
    "SPG7",
    "SPR",
    "SPTAN1",
    "SPTBN2",
    "SPTBN4",
    "SPTLC2",
    "SQSTM1",
    "STAC3",
    "STAMBP",
    "STIM1",
    "STN1",
    "STUB1",
    "STXBP1",
    "SUCLA2",
    "SUCLG1",
    "SUFU",
    "SUMF1",
    "SUOX",
    "SURF1",
    "SVBP",
    "SYNE1",
    "SYNE2",
    "SYNJ1",
    "SYT14",
    "SYT2",
    "TACO1",
    "TAF1",
    "TAF2",
    "TAFAZZIN",
    "TAMM41",
    "TANGO2",
    "TARDBP",
    "TBC1D20",
    "TBC1D23",
    "TBC1D24",
    "TBCD",
    "TBCE",
    "TBCK",
    "TBK1",
    "TBP",
    "TCAP",
    "TCF4",
    "TCN2",
    "TCTN1",
    "TCTN2",
    "TCTN3",
    "TDP1",
    "TDP2",
    "TECPR2",
    "TELO2",
    "TENM4",
    "TFG",
    "TGM6",
    "TH",
    "THAP1",
    "THAP11",
    "THG1L",
    "THOC2",
    "TIA1",
    "TIMM8A",
    "TIMMDC1",
    "TINF2",
    "TK2",
    "TMEM107",
    "TMEM126B",
    "TMEM138",
    "TMEM216",
    "TMEM231",
    "TMEM237",
    "TMEM240",
    "TMEM43",
    "TMEM67",
    "TMEM70",
    "TMX2",
    "TNNC2",
    "TNNI2",
    "TNNT1",
    "TNNT3",
    "TNPO3",
    "TNRC6A",
    "TOR1A",
    "TOR1AIP1",
    "TP53RK",
    "TPI1",
    "TPK1",
    "TPM2",
    "TPM3",
    "TPP1",
    "TRAPPC11",
    "TRAPPC12",
    "TRAPPC4",
    "TRDN",
    "TREM2",
    "TREX1",
    "TRIM32",
    "TRIP4",
    "TRMT5",
    "TRNT1",
    "TRPC3",
    "TRPM7",
    "TRPV4",
    "TSEN15",
    "TSEN2",
    "TSEN54",
    "TSFM",
    "TTBK2",
    "TTC19",
    "TTC21B",
    "TTN",
    "TTPA",
    "TTR",
    "TUBA4A",
    "TUBB",
    "TUBB3",
    "TUBB4A",
    "TUBG1",
    "TWNK",
    "TXN2",
    "TYMP",
    "TYROBP",
    "UBA1",
    "UBA5",
    "UBE3A",
    "UBQLN2",
    "UBTF",
    "UCHL1",
    "UFC1",
    "UNC45B",
    "UNC80",
    "UPB1",
    "UQCC2",
    "UQCC3",
    "UQCRB",
    "UQCRC2",
    "UQCRFS1",
    "UQCRQ",
    "UROC1",
    "USP18",
    "VAC14",
    "VAMP1",
    "VAPB",
    "VARS2",
    "VCP",
    "VLDLR",
    "VMA21",
    "VPS11",
    "VPS13A",
    "VPS13C",
    "VPS13D",
    "VPS16",
    "VPS35",
    "VPS37A",
    "VPS51",
    "VPS53",
    "VRK1",
    "VWA1",
    "VWA3B",
    "WARS2",
    "WASHC5",
    "WDR26",
    "WDR45",
    "WDR62",
    "WDR73",
    "WDR81",
    "WFS1",
    "WNK1",
    "WWOX",
    "XK",
    "XPA",
    "XPNPEP3",
    "XPR1",
    "XRCC1",
    "XRCC4",
    "XYLT1",
    "YARS2",
    "YME1L1",
    "ZC4H2",
    "ZFHX3",
    "ZFYVE26",
    "ZIC2",
    "ZIC3",
    "ZNF142",
    "ZNF335",
    "ZNF423",
    "ZNHIT3"
  ],
  "/test/Intellectual Disability Panel": [
    "ABCD1",
    "ACAT1",
    "ACOX1",
    "ACSL4",
    "ACTB",
    "ACTG1",
    "ACY1",
    "ADAR",
    "ADNP",
    "ADSL",
    "AFG2A",
    "AGA",
    "AGTR2",
    "AHDC1",
    "AHI1",
    "AIFM1",
    "ALDH18A1",
    "ALDH4A1",
    "ALDH5A1",
    "ALDH7A1",
    "ALG1",
    "ALG11",
    "ALG12",
    "ALG13",
    "ALG2",
    "ALG3",
    "ALG6",
    "ALX4",
    "AMER1",
    "ANK3",
    "ANKRD11",
    "AP1S1",
    "AP1S2",
    "AP3B1",
    "AP4B1",
    "AP4E1",
    "AP4M1",
    "AP4S1",
    "ARG1",
    "ARHGEF6",
    "ARHGEF9",
    "ARID1A",
    "ARID1B",
    "ARSA",
    "ARX",
    "ASAH1",
    "ASNS",
    "ASPM",
    "ASS1",
    "ASXL1",
    "ASXL3",
    "ATL1",
    "ATP10A",
    "ATP13A2",
    "ATP1A2",
    "ATP1A3",
    "ATP6AP2",
    "ATP7A",
    "ATRX",
    "AUH",
    "AUTS2",
    "AVPR1A",
    "AVPR2",
    "BBIP1",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS7",
    "BBS9",
    "BCAP31",
    "BCL11A",
    "BCOR",
    "BCS1L",
    "BDNF",
    "BIN1",
    "BRAF",
    "BRAT1",
    "BRD4",
    "BRSK2",
    "BRWD3",
    "BUB1B",
    "CA2",
    "CACNA1A",
    "CACNA1C",
    "CACNA1E",
    "CACNG2",
    "CAMK2B",
    "CAMTA1",
    "CANT1",
    "CASK",
    "CBL",
    "CBS",
    "CC2D1A",
    "CC2D2A",
    "CCDC22",
    "CCDC88C",
    "CDC42",
    "CDH15",
    "CDK13",
    "CDK16",
    "CDKL5",
    "CDKN1C",
    "CEP290",
    "CEP41",
    "CEP57",
    "CERT1",
    "CHAMP1",
    "CHD2",
    "CHD7",
    "CHD8",
    "CHRNA4",
    "CIC",
    "CLCN4",
    "CLIC2",
    "CLN3",
    "CLN5",
    "CLN6",
    "CLN8",
    "CLTC",
    "CNKSR2",
    "CNTNAP2",
    "CNTNAP5",
    "COG5",
    "COG7",
    "COG8",
    "COL4A1",
    "CP",
    "CPA6",
    "CPS1",
    "CRADD",
    "CRBN",
    "CREBBP",
    "CSNK2A1",
    "CTC1",
    "CTCF",
    "CTNNB1",
    "CTNND2",
    "CTSA",
    "CTSD",
    "CTSF",
    "CUL3",
    "CUL4B",
    "CYB5R3",
    "CYP27A1",
    "D2HGDH",
    "DARS2",
    "DBT",
    "DCX",
    "DDC",
    "DDX3X",
    "DEAF1",
    "DHCR24",
    "DHCR7",
    "DKC1",
    "DLG3",
    "DLGAP2",
    "DMD",
    "DNM1",
    "DNM1L",
    "DNMT3A",
    "DOCK4",
    "DOCK6",
    "DPF2",
    "DPP10",
    "DPP6",
    "DPYD",
    "DYNC1H1",
    "DYRK1A",
    "EBP",
    "EEF1A2",
    "EFNB1",
    "EFTUD2",
    "EHMT1",
    "EIF2S3",
    "ELOVL4",
    "EP300",
    "ERCC2",
    "ERCC3",
    "ERCC4",
    "ERCC5",
    "ERCC6",
    "ERCC8",
    "EZH2",
    "FAAH2",
    "FANCB",
    "FANCG",
    "FBN1",
    "FBXO11",
    "FGD1",
    "FGFR1",
    "FGFR2",
    "FGFR3",
    "FKRP",
    "FKTN",
    "FLNA",
    "FOLR1",
    "FOXG1",
    "FOXP1",
    "FOXP2",
    "FRMPD4",
    "FTO",
    "FTSJ1",
    "G6PC3",
    "GABBR2",
    "GABRB3",
    "GABRG2",
    "GALC",
    "GALE",
    "GAMT",
    "GAN",
    "GATAD2B",
    "GATM",
    "GBA1",
    "GBE1",
    "GCK",
    "GDI1",
    "GFAP",
    "GFM1",
    "GHR",
    "GK",
    "GLB1",
    "GLI3",
    "GLRA1",
    "GLUL",
    "GLYCTK",
    "GM2A",
    "GNAO1",
    "GNAS",
    "GNPAT",
    "GNPTAB",
    "GNPTG",
    "GNS",
    "GPC3",
    "GRIA3",
    "GRIK2",
    "GRIN1",
    "GRIN2A",
    "GRIN2B",
    "GRM1",
    "GRN",
    "GSPT2",
    "GSS",
    "GUSB",
    "HAX1",
    "HCCS",
    "HCFC1",
    "HDAC4",
    "HDAC8",
    "HECW2",
    "HEPACAM",
    "HEXA",
    "HEXB",
    "HGSNAT",
    "HIVEP2",
    "HNRNPK",
    "HNRNPU",
    "HOXA1",
    "HPD",
    "HPRT1",
    "HRAS",
    "HSD17B10",
    "HSPD1",
    "HUWE1",
    "HYCC1",
    "IDS",
    "IDUA",
    "IGBP1",
    "IGF1",
    "IGF1R",
    "IL1RAPL1",
    "IMMP2L",
    "IMPA1",
    "INSR",
    "IQSEC2",
    "IRX5",
    "ITGA7",
    "ITPR1",
    "KANSL1",
    "KAT6A",
    "KAT6B",
    "KATNAL2",
    "KCNA2",
    "KCNB1",
    "KCNH1",
    "KCNJ10",
    "KCNJ11",
    "KCNK9",
    "KCNQ2",
    "KCNT1",
    "KCTD13",
    "KCTD7",
    "KDM5B",
    "KDM5C",
    "KDM6A",
    "KIF11",
    "KIF1A",
    "KIF21A",
    "KIF5A",
    "KIF7",
    "KIFBP",
    "KIRREL3",
    "KLF8",
    "KMT2A",
    "KMT2B",
    "KMT2D",
    "KMT2E",
    "KMT5B",
    "KRAS",
    "L1CAM",
    "LAMA2",
    "LAMC3",
    "LAMP2",
    "LARGE1",
    "LAS1L",
    "LHX3",
    "LIG4",
    "LMBRD1",
    "LYST",
    "LZTR1",
    "MACF1",
    "MAGEL2",
    "MAGT1",
    "MAN1B1",
    "MAN2B1",
    "MANBA",
    "MAOA",
    "MAP2K1",
    "MAP2K2",
    "MAPK8IP3",
    "MAT1A",
    "MBD5",
    "MBTPS2",
    "MCCC1",
    "MCCC2",
    "MCOLN1",
    "MCPH1",
    "MECP2",
    "MED12",
    "MED13L",
    "MED17",
    "MED23",
    "MEF2C",
    "MFSD8",
    "MGAT2",
    "MID1",
    "MKKS",
    "MMADHC",
    "MOCS1",
    "MOCS2",
    "MRAP",
    "MTFMT",
    "MTHFR",
    "MTOR",
    "MTR",
    "MYCN",
    "MYO5A",
    "MYT1L",
    "NAA10",
    "NAA15",
    "NAGA",
    "NAGLU",
    "NALCN",
    "NBN",
    "NDP",
    "NDUFA1",
    "NDUFAF5",
    "NDUFS1",
    "NEGR1",
    "NEXMIF",
    "NF1",
    "NFIA",
    "NFIX",
    "NGF",
    "NGLY1",
    "NHEJ1",
    "NHP2",
    "NHS",
    "NIPBL",
    "NLGN3",
    "NLGN4X",
    "NONO",
    "NPC1",
    "NPC2",
    "NPHP3",
    "NR2F1",
    "NRAS",
    "NRXN1",
    "NSD1",
    "NSDHL",
    "NSUN2",
    "NTNG1",
    "OCRL",
    "OFD1",
    "OGT",
    "OPHN1",
    "ORC1",
    "OTC",
    "PACS1",
    "PACS2",
    "PAFAH1B1",
    "PAH",
    "PAK3",
    "PAX6",
    "PCBD1",
    "PCDH19",
    "PCDH9",
    "PCGF2",
    "PCNT",
    "PDE4D",
    "PDHA1",
    "PDHX",
    "PDSS1",
    "PEX7",
    "PGAP3",
    "PGK1",
    "PHF21A",
    "PHF6",
    "PHF8",
    "PHIP",
    "PHKA2",
    "PHKG2",
    "PIGA",
    "PIGL",
    "PIGO",
    "PIGV",
    "PIP5K1B",
    "PLA2G6",
    "PLP1",
    "PMM2",
    "PNKP",
    "POGZ",
    "POLG",
    "POMGNT1",
    "POMT1",
    "POMT2",
    "PON3",
    "PORCN",
    "POU1F1",
    "PPM1D",
    "PPOX",
    "PPP1CB",
    "PPP2R1A",
    "PPP2R5D",
    "PPP3CA",
    "PPT1",
    "PQBP1",
    "PRKAR1A",
    "PRMT7",
    "PRPS1",
    "PRSS12",
    "PTCHD1",
    "PTEN",
    "PTPN11",
    "PTS",
    "PURA",
    "PYCR1",
    "PYGL",
    "QDPR",
    "RAB39B",
    "RAD21",
    "RAF1",
    "RAI1",
    "RAPSN",
    "RBBP8",
    "RBFOX1",
    "RBM10",
    "RELN",
    "RIT1",
    "RORA",
    "RPGRIP1L",
    "RPL10",
    "RPS6KA3",
    "SACS",
    "SAMHD1",
    "SATB2",
    "SCN1A",
    "SCN1B",
    "SCN2A",
    "SCN3A",
    "SCN8A",
    "SDCCAG8",
    "SETBP1",
    "SETD5",
    "SGSH",
    "SHANK2",
    "SHANK3",
    "SHOC2",
    "SHROOM4",
    "SIL1",
    "SIN3A",
    "SKI",
    "SLC13A5",
    "SLC16A2",
    "SLC20A2",
    "SLC25A12",
    "SLC25A13",
    "SLC25A15",
    "SLC2A1",
    "SLC2A2",
    "SLC35A2",
    "SLC35C1",
    "SLC46A1",
    "SLC4A4",
    "SLC5A5",
    "SLC6A1",
    "SLC6A4",
    "SLC6A8",
    "SLC7A7",
    "SLC9A6",
    "SLC9A9",
    "SLX4",
    "SMARCA2",
    "SMARCA4",
    "SMARCB1",
    "SMARCE1",
    "SMC1A",
    "SMC3",
    "SMG6",
    "SMS",
    "SNAP25",
    "SNIP1",
    "SNRPN",
    "SOBP",
    "SON",
    "SOS1",
    "SOS2",
    "SOX10",
    "SOX11",
    "SOX2",
    "SOX3",
    "SOX5",
    "SPAST",
    "SPR",
    "SPRED1",
    "SPTAN1",
    "SRD5A3",
    "SRPX2",
    "ST3GAL3",
    "ST7",
    "STAG1",
    "STAT5B",
    "STK3",
    "STRA6",
    "STX11",
    "STXBP1",
    "SUCLG1",
    "SURF1",
    "SYN1",
    "SYNGAP1",
    "SYP",
    "SYT14",
    "TAF1",
    "TAF6",
    "TBC1D24",
    "TBCE",
    "TBCK",
    "TBL1XR1",
    "TBR1",
    "TBX1",
    "TCF20",
    "TCF4",
    "TECR",
    "TELO2",
    "TET3",
    "TGIF1",
    "TH",
    "THOC2",
    "THRB",
    "TIMM8A",
    "TINF2",
    "TMCO1",
    "TMEM165",
    "TMEM216",
    "TMEM231",
    "TMEM67",
    "TMEM70",
    "TPH2",
    "TPK1",
    "TPP1",
    "TRAPPC9",
    "TRHR",
    "TRIO",
    "TRIP12",
    "TRRAP",
    "TSC1",
    "TSC2",
    "TSHR",
    "TSPAN7",
    "SKIC3",
    "TTC8",
    "TUBA1A",
    "TUBA8",
    "TUBB2B",
    "TUBB3",
    "TUSC3",
    "TWIST1",
    "UBE2A",
    "UBE3A",
    "UNC80",
    "UPB1",
    "UPF3B",
    "UROC1",
    "USP9X",
    "VLDLR",
    "VPS13B",
    "WAC",
    "WDR13",
    "WDR45",
    "WDR62",
    "WDR73",
    "WDR81",
    "WWOX",
    "XPNPEP3",
    "ZBTB16",
    "ZBTB18",
    "ZBTB20",
    "ZBTB24",
    "ZC4H2",
    "ZCCHC12",
    "ZDHHC9",
    "ZEB2",
    "ZFP57",
    "ZFYVE26",
    "ZIC2",
    "ZMIZ1",
    "ZMYM3",
    "ZMYND11",
    "ZNF41",
    "ZNF507",
    "ZNF674",
    "ZNF711",
    "ZNF804A",
    "ZNF81",
    "ZNHIT6"
  ],
  "/test/Macrocephaly Panel": [
    "ABCC9",
    "ADK",
    "AKT1",
    "AKT2",
    "AKT3",
    "ANKH",
    "ASPA",
    "ASXL2",
    "BLTP1",
    "BRSK2",
    "BRWD3",
    "CCND2",
    "CDKN1C",
    "CHD3",
    "CHD4",
    "CHD8",
    "CUL4B",
    "D2HGDH",
    "DHCR24",
    "DICER1",
    "DIS3L2",
    "DNMT3A",
    "DVL1",
    "EED",
    "EIF2B5",
    "ERF",
    "ETFA",
    "ETFB",
    "ETFDH",
    "EXT2",
    "EZH2",
    "FBLN5",
    "FBN1",
    "FGFR3",
    "FOXP1",
    "GATAD2B",
    "GCDH",
    "GFAP",
    "GLI3",
    "GPC3",
    "GPC4",
    "GPSM2",
    "GRIA3",
    "H1-4",
    "H19",
    "HEPACAM",
    "HERC1",
    "HRAS",
    "HUWE1",
    "KCNH1",
    "KDM1A",
    "KIF7",
    "KMT2E",
    "KPTN",
    "KRAS",
    "L1CAM",
    "LAMB1",
    "LBR",
    "MED12",
    "MITF",
    "MLC1",
    "MPDZ",
    "MTM1",
    "MTOR",
    "NF1",
    "NFIA",
    "NFIB",
    "NFIX",
    "NONO",
    "NPR2",
    "NRAS",
    "NSD1",
    "ODC1",
    "OFD1",
    "PDGFRB",
    "PHF21A",
    "PHF6",
    "PIGA",
    "PIGM",
    "PIK3CA",
    "PIK3R2",
    "PPP1CB",
    "PPP2R5D",
    "PTCH1",
    "PTEN",
    "RAB39B",
    "RIN2",
    "RNF125",
    "RNF135",
    "SETD2",
    "SHANK3",
    "SHOC2",
    "SNX14",
    "SOS1",
    "SPRED1",
    "STRADA",
    "SUFU",
    "SUZ12",
    "SYN1",
    "SZT2",
    "TBC1D7",
    "TCF20",
    "TGFB3",
    "TMEM94",
    "TRIO",
    "TRIP12",
    "TSC1",
    "TSC2",
    "UPF3B",
    "WASHC5",
    "WNT5A",
    "ZBTB20",
    "ZBTB7A"
  ],
  "/test/Mitochondrial Genome Sequencing": [
    "MT-ATP6",
    "MT-ATP8",
    "MT-CO1",
    "MT-CO2",
    "MT-CO3",
    "MT-CYB",
    "MT-ND1",
    "MT-ND2",
    "MT-ND3",
    "MT-ND4",
    "MT-ND4L",
    "MT-ND5",
    "MT-ND6",
    "MT-RNR1",
    "MT-RNR2",
    "MT-TA",
    "MT-TC",
    "MT-TD",
    "MT-TE",
    "MT-TF",
    "MT-TG",
    "MT-TH",
    "MT-TI",
    "MT-TK",
    "MT-TL1",
    "MT-TL2",
    "MT-TM",
    "MT-TN",
    "MT-TP",
    "MT-TQ",
    "MT-TR",
    "MT-TS1",
    "MT-TS2",
    "MT-TT",
    "MT-TV",
    "MT-TW",
    "MT-TY"
  ],
  "/test/Bone Fracture Panel": [
    "ABCC6",
    "ALPI",
    "ALPL",
    "AMER1",
    "ANKH",
    "ANO5",
    "AP2S1",
    "ASCC1",
    "ATP7A",
    "B3GAT3",
    "B4GALT7",
    "BMP1",
    "CA2",
    "CASR",
    "CDK5RAP2",
    "CLCN5",
    "CLCN7",
    "COL1A1",
    "COL1A2",
    "CREB3L1",
    "CRTAP",
    "CTNS",
    "CTSK",
    "CYP24A1",
    "CYP27B1",
    "CYP2R1",
    "DMP1",
    "DSPP",
    "ENPP1",
    "FAH",
    "FAM20C",
    "FERMT3",
    "FGF23",
    "FGFR1",
    "FGFR3",
    "FKBP10",
    "GALNT3",
    "GJA1",
    "GNA11",
    "GNAS",
    "GORAB",
    "GPAA1",
    "HPGD",
    "HRAS",
    "IFITM5",
    "KDELR2",
    "KL",
    "KRAS",
    "LEMD3",
    "LRP4",
    "LRP5",
    "LRRK1",
    "MBTPS2",
    "MEPE",
    "MESD",
    "MTAP",
    "NBAS",
    "NOTCH2",
    "NRAS",
    "NTRK1",
    "OCRL",
    "OSTM1",
    "P3H1",
    "P4HB",
    "PHEX",
    "PKDCC",
    "PLEKHM1",
    "PLOD2",
    "PLS3",
    "PPIB",
    "PRKAR1A",
    "PTDSS1",
    "PTH1R",
    "SEC24D",
    "SERPINF1",
    "SERPINH1",
    "SFRP4",
    "SGMS2",
    "SH3PXD2B",
    "SLC26A2",
    "SLC29A3",
    "SLC2A2",
    "SLC34A1",
    "SLC34A3",
    "SLC5A6",
    "SLC9A3R1",
    "SLCO2A1",
    "SMS",
    "SNX10",
    "SOST",
    "SOX9",
    "SP7",
    "SPARC",
    "SQSTM1",
    "SUCO",
    "TAPT1",
    "TBXAS1",
    "TCIRG1",
    "TENT5A",
    "TGFB1",
    "TMEM38B",
    "TNFRSF11A",
    "TNFRSF11B",
    "TNFSF11",
    "TRAF6",
    "TRIP4",
    "TYROBP",
    "VDR",
    "WNT1",
    "WNT3A",
    "XYLT2",
    "ZBTB20"
],
  "/test/Short Stature Panel": [
    "ACAN",
    "ACP5",
    "ACTB",
    "ACTG1",
    "AGPS",
    "ALMS1",
    "ALPL",
    "AMMECR1",
    "ANKH",
    "ANKRD11",
    "ANO5",
    "ARCN1",
    "ARHGAP31",
    "ARID1A",
    "ARID1B",
    "ARSL",
    "ATP6V0A2",
    "ATR",
    "ATRIP",
    "B3GALT6",
    "B3GAT3",
    "B4GALT7",
    "BLM",
    "BMP1",
    "BMP2",
    "BMPR1B",
    "BRAF",
    "BRF1",
    "BTK",
    "CA2",
    "CANT1",
    "CASK",
    "CASR",
    "CBL",
    "CC2D2A",
    "CCDC8",
    "CCN6",
    "CDC45",
    "CDC6",
    "CDKN1C",
    "CDT1",
    "CENPJ",
    "CEP152",
    "CEP290",
    "CEP63",
    "CHST14",
    "CHST3",
    "CHSY1",
    "CILK1",
    "CLCN5",
    "CLCN7",
    "COL10A1",
    "COL11A1",
    "COL11A2",
    "COL1A1",
    "COL1A2",
    "COL27A1",
    "COL2A1",
    "COL9A1",
    "COL9A2",
    "COL9A3",
    "COMP",
    "CREBBP",
    "CRIPT",
    "CRTAP",
    "CTSK",
    "CUL7",
    "DDR2",
    "DHCR24",
    "DHCR7",
    "DLL3",
    "DLX3",
    "DMP1",
    "DNA2",
    "DONSON",
    "DVL1",
    "DYM",
    "DYNC2H1",
    "EBP",
    "EIF2AK3",
    "ENPP1",
    "EP300",
    "ERCC6",
    "ERCC8",
    "ESCO2",
    "EVC",
    "EVC2",
    "EXT1",
    "EXT2",
    "FAM20C",
    "FANCA",
    "FANCC",
    "FANCG",
    "FBLN1",
    "FBN1",
    "FBXW4",
    "FERMT3",
    "FGD1",
    "FGF10",
    "FGF23",
    "FGFR1",
    "FGFR2",
    "FGFR3",
    "FKBP10",
    "FLNA",
    "FLNB",
    "FMN1",
    "FN1",
    "GALNT3",
    "GDF5",
    "GH1",
    "GHR",
    "GHRHR",
    "GHSR",
    "GLI2",
    "GLI3",
    "GNAS",
    "GNPAT",
    "GORAB",
    "GPC3",
    "GPC6",
    "GREM1",
    "H19",
    "HDAC4",
    "HDAC8",
    "HES7",
    "HESX1",
    "HMGA2",
    "HPGD",
    "HRAS",
    "HSPG2",
    "IDUA",
    "IFITM5",
    "IFT122",
    "IFT140",
    "IFT80",
    "IGF1",
    "IGF1R",
    "IGF2",
    "IGFALS",
    "IHH",
    "INSR",
    "KDM6A",
    "KIF22",
    "KIF7",
    "KMT2D",
    "KRAS",
    "LARP7",
    "LEMD3",
    "LFNG",
    "LHX3",
    "LHX4",
    "LIFR",
    "LIG4",
    "LMBR1",
    "LMNA",
    "LRP4",
    "LRP5",
    "LZTR1",
    "MAFB",
    "MAP2K1",
    "MAP2K2",
    "MATN3",
    "MESP2",
    "MGP",
    "MKS1",
    "MMP13",
    "MMP2",
    "MMP9",
    "MRAS",
    "MYCN",
    "NBN",
    "NEK1",
    "NF1",
    "NIPBL",
    "NKX3-2",
    "NOG",
    "NOTCH2",
    "NPPC",
    "NPR2",
    "NRAS",
    "NSMCE2",
    "OBSL1",
    "ORC1",
    "ORC4",
    "ORC6",
    "OSGEP",
    "OSTM1",
    "OTX2",
    "P3H1",
    "PAPPA2",
    "PAPSS2",
    "PCNT",
    "PDE4D",
    "PEX7",
    "PHEX",
    "PIGV",
    "PIK3R1",
    "PISD",
    "PITX1",
    "PLK4",
    "PLOD2",
    "POC1A",
    "POP1",
    "POU1F1",
    "PPIB",
    "PPP1CB",
    "PPP3CA",
    "PRKAR1A",
    "PRMT7",
    "PROKR2",
    "PROP1",
    "PTH1R",
    "PTHLH",
    "PTPN11",
    "PUF60",
    "PYCR1",
    "RAD21",
    "RAF1",
    "RALA",
    "RASA2",
    "RBBP8",
    "RECQL4",
    "RIT1",
    "RNU4ATAC",
    "ROR2",
    "RPGRIP1L",
    "RPS6KA3",
    "RRAS",
    "RTTN",
    "RUNX2",
    "SALL1",
    "SALL4",
    "SERPINF1",
    "SERPINH1",
    "SGMS2",
    "SH3PXD2B",
    "SHH",
    "SHOC2",
    "SHOX",
    "SLC26A2",
    "SLC34A3",
    "SLC35D1",
    "SLC39A13",
    "SMAD4",
    "SMARCA2",
    "SMARCA4",
    "SMARCAL1",
    "SMARCB1",
    "SMARCE1",
    "SMC1A",
    "SMC3",
    "SOS1",
    "SOS2",
    "SOST",
    "SOX11",
    "SOX2",
    "SOX3",
    "SOX9",
    "SP7",
    "SPRED1",
    "SRCAP",
    "STAT5B",
    "SULF1",
    "TALDO1",
    "TBCE",
    "TBX15",
    "TBX2",
    "TBX3",
    "TBX5",
    "TBX6",
    "TBXAS1",
    "TCIRG1",
    "TGFB1",
    "THPO",
    "TMEM216",
    "TMEM67",
    "TNFRSF11A",
    "TNFRSF11B",
    "TNFSF11",
    "TOP3A",
    "TP63",
    "TREM2",
    "TRIM37",
    "TRIP11",
    "TRMT10A",
    "TRPS1",
    "TRPV4",
    "TYROBP",
    "WDR35",
    "WNT3",
    "WNT5A",
    "WNT7A",
    "XRCC4",
    "ZMPSTE24"
],
  "/test/Comprehensive Renal Disease": [
    "ABCC6",
    "ACE",
    "ACTB",
    "ACTG1",
    "ACTG2",
    "ACTN4",
    "ADA2",
    "ADAMTS13",
    "ADAMTS9",
    "ADCY10",
    "AGPAT2",
    "AGT",
    "AGTR1",
    "AGXT",
    "AHI1",
    "ALG1",
    "ALG8",
    "ALG9",
    "ALMS1",
    "ALPL",
    "AMN",
    "ANKFY1",
    "ANKS6",
    "ANLN",
    "ANOS1",
    "AP2S1",
    "APOA1",
    "APOC2",
    "APOL1",
    "APRT",
    "AQP2",
    "ARHGAP24",
    "ARHGDIA",
    "ARL13B",
    "ARL6",
    "ARMC9",
    "ATP6V0A4",
    "ATP6V1B1",
    "ATP6V1C2",
    "ATP7B",
    "ATXN10",
    "AVP",
    "AVPR2",
    "B2M",
    "B9D1",
    "B9D2",
    "BBIP1",
    "BBS1",
    "BBS10",
    "BBS12",
    "BBS2",
    "BBS4",
    "BBS5",
    "BBS7",
    "BBS9",
    "BCS1L",
    "BICC1",
    "BMP4",
    "BNC2",
    "BRAF",
    "BSND",
    "C2CD3",
    "C3",
    "CA2",
    "CACNA1D",
    "CACNA1H",
    "CASR",
    "CC2D2A",
    "CD151",
    "CD2AP",
    "CD46",
    "CDC73",
    "CDK20",
    "CDKN1C",
    "CENPF",
    "CEP104",
    "CEP120",
    "CEP164",
    "CEP290",
    "CEP41",
    "CEP83",
    "CFAP410",
    "CFAP418",
    "CFB",
    "CFH",
    "CFHR1",
    "CFHR3",
    "CFHR5",
    "CFI",
    "CHD1L",
    "CHD7",
    "CHRM3",
    "CHRNA3",
    "CILK1",
    "CISD2",
    "CLCN2",
    "CLCN5",
    "CLCNKB",
    "CLDN10",
    "CLDN16",
    "CLDN19",
    "CNNM2",
    "COL4A1",
    "COL4A3",
    "COL4A4",
    "COL4A5",
    "COL4A6",
    "COQ2",
    "COQ6",
    "COQ8B",
    "COX10",
    "CPLANE1",
    "CPT2",
    "CRB2",
    "CREBBP",
    "CSPP1",
    "CTNS",
    "CTU2",
    "CUBN",
    "CUL3",
    "CYP11B1",
    "CYP11B2",
    "CYP17A1",
    "CYP24A1",
    "CYP27B1",
    "CYP2R1",
    "DCDC2",
    "DDX59",
    "DGKE",
    "DHCR7",
    "DHTKD1",
    "DICER1",
    "DLC1",
    "DLG5",
    "DMP1",
    "DNAJB11",
    "DNASE1L3",
    "DSTYK",
    "DYNC2H1",
    "DYNC2I1",
    "DZIP1L",
    "EBP",
    "EGF",
    "EHHADH",
    "EIF2AK3",
    "ELP1",
    "EMP2",
    "ENPP1",
    "EYA1",
    "FAH",
    "FAM20A",
    "FAN1",
    "FANCA",
    "FAT1",
    "FAT4",
    "FGA",
    "FGF10",
    "FGF20",
    "FGF23",
    "FGFR1",
    "FGFR2",
    "FN1",
    "FOXC1",
    "FOXC2",
    "FOXI1",
    "FOXP1",
    "FOXP3",
    "FRAS1",
    "FREM1",
    "FREM2",
    "FXYD2",
    "G6PC1",
    "GALNT3",
    "GANAB",
    "GAPVD1",
    "GATA3",
    "GATM",
    "GCM2",
    "GLA",
    "GLI3",
    "GLIS2",
    "GLIS3",
    "GNA11",
    "GNAS",
    "GON7",
    "GPC3",
    "GREB1L",
    "GRHPR",
    "GRIP1",
    "GSN",
    "HAAO",
    "HGD",
    "HNF1A",
    "HNF1B",
    "HNF4A",
    "HOGA1",
    "HOXA13",
    "HPRT1",
    "HPS1",
    "HPSE2",
    "HSD11B2",
    "HYLS1",
    "IFT122",
    "IFT140",
    "IFT172",
    "IFT27",
    "IFT43",
    "IFT74",
    "IFT80",
    "INF2",
    "INPP5E",
    "INVS",
    "IQCB1",
    "ITGA3",
    "ITGA6",
    "ITGA8",
    "ITGB4",
    "ITSN1",
    "ITSN2",
    "JAG1",
    "KANK1",
    "KANK2",
    "KANK4",
    "KANSL1",
    "KAT6B",
    "KATNIP",
    "KCNA1",
    "KCNJ1",
    "KCNJ10",
    "KCNJ5",
    "KCTD1",
    "KIAA0586",
    "KIAA0753",
    "KIF14",
    "KIF7",
    "KIRREL1",
    "KLHL3",
    "KMT2D",
    "KRAS",
    "KYNU",
    "LAGE3",
    "LAMA5",
    "LAMB2",
    "LCAT",
    "LDHA",
    "LIFR",
    "LMNA",
    "LMX1B",
    "LPIN1",
    "LRIG2",
    "LRP2",
    "LRP4",
    "LRP5",
    "LYZ",
    "LZTFL1",
    "MAFB",
    "MAGED2",
    "MAGI2",
    "MAP2K1",
    "MAP2K2",
    "MAPKBP1",
    "MEFV",
    "MKKS",
    "MKS1",
    "MMACHC",
    "MMUT",
    "MNX1",
    "MOCOS",
    "MOCS1",
    "MOCS2",
    "MUC1",
    "MVK",
    "MYCN",
    "MYH9",
    "MYO1E",
    "NEK1",
    "NEK8",
    "NEU1",
    "NF1",
    "NHERF1",
    "NIPBL",
    "NLRP3",
    "NOTCH2",
    "NPHP1",
    "NPHP3",
    "NPHP4",
    "NPHS1",
    "NPHS2",
    "NR0B1",
    "NR3C2",
    "NRIP1",
    "NSD1",
    "NSDHL",
    "NUP107",
    "NUP133",
    "NUP160",
    "NUP205",
    "NUP85",
    "NUP93",
    "OCRL",
    "OFD1",
    "OPLAH",
    "OSGEP",
    "PARN",
    "PAX2",
    "PBX1",
    "PCBD1",
    "PDE6D",
    "PDSS1",
    "PDSS2",
    "PHEX",
    "PKD1",
    "PKD2",
    "PKHD1",
    "PLCE1",
    "PLG",
    "PMM2",
    "PODXL",
    "PRKCSH",
    "PRODH",
    "PROKR2",
    "PRPS1",
    "PTPRO",
    "REN",
    "RET",
    "RMND1",
    "ROBO1",
    "ROBO2",
    "RPGRIP1L",
    "RPL11",
    "RPL35A",
    "RPL5",
    "RPS10",
    "RPS19",
    "RPS24",
    "RPS26",
    "RPS7",
    "RRM2B",
    "SALL1",
    "SALL4",
    "SARS2",
    "SCARB2",
    "SCN4A",
    "SCNN1A",
    "SCNN1B",
    "SCNN1G",
    "SDCCAG8",
    "SEC61A1",
    "SEC63",
    "SEMA3E",
    "SGPL1",
    "SI",
    "SIX1",
    "SIX2",
    "SIX5",
    "SLC12A1",
    "SLC12A3",
    "SLC17A5",
    "SLC22A12",
    "SLC26A1",
    "SLC2A2",
    "SLC2A9",
    "SLC34A1",
    "SLC34A3",
    "SLC37A4",
    "SLC3A1",
    "SLC41A1",
    "SLC4A1",
    "SLC4A4",
    "SLC5A1",
    "SLC5A2",
    "SLC6A19",
    "SLC7A7",
    "SLC7A9",
    "SLIT2",
    "SLX4",
    "SMARCAL1",
    "SMC1A",
    "SOX11",
    "SOX17",
    "SOX18",
    "SRCAP",
    "SRGAP1",
    "STAR",
    "STX16",
    "TBC1D8B",
    "TBX18",
    "TCTN1",
    "TCTN2",
    "TCTN3",
    "TFAP2A",
    "THBD",
    "TMEM107",
    "TMEM138",
    "TMEM216",
    "TMEM231",
    "TMEM237",
    "TMEM67",
    "TNS2",
    "TNXB",
    "TP53RK",
    "TP63",
    "TPRKB",
    "TRAF3IP1",
    "TRAP1",
    "TRIM32",
    "TRPC6",
    "TRPM6",
    "TSC1",
    "TSC2",
    "TTC21B",
    "TTC8",
    "TTR",
    "TXNDC15",
    "UMOD",
    "UPK3A",
    "UQCC2",
    "VDR",
    "VHL",
    "VIPAS39",
    "VPS33B",
    "WAS",
    "WDPCP",
    "WDR19",
    "WDR35",
    "WDR72",
    "WDR73",
    "WFS1",
    "WNK1",
    "WNK4",
    "WNT4",
    "WNT5A",
    "WT1",
    "XDH",
    "XPNPEP3",
    "XPO5",
    "YRDC",
    "ZMYM2",
    "ZNF423"
],
  "/test/Parkinson’s Disease, Alzheimer’s Disease, and Dementia": [
    "AFG3L2",
    "APOE",
    "APP",
    "ATP13A2",
    "ATP1A3",
    "ATP6AP2",
    "CHCHD10",
    "CHMP2B",
    "CP",
    "CSF1R",
    "DCTN1",
    "DNAJC5",
    "DNAJC6",
    "DNMT1",
    "EIF4G1",
    "FBXO7",
    "FUS",
    "GBA1",
    "GCH1",
    "GRN",
    "HTRA2",
    "ITM2B",
    "LRRK2",
    "MAPT",
    "NOTCH3",
    "PARK7",
    "PINK1",
    "PLA2G6",
    "POLG",
    "PRKN",
    "PRKRA",
    "PRNP",
    "PSEN1",
    "PSEN2",
    "SLC20A2",
    "SLC6A3",
    "SNCA",
    "SNCB",
    "SORL1",
    "SQSTM1",
    "SYNJ1",
    "TAF1",
    "TARDBP",
    "TBK1",
    "TH",
    "TREM2",
    "TYROBP",
    "UBQLN2",
    "UCHL1",
    "VCP",
    "VPS13A",
    "VPS35",
    "XPR1"
  ],
  "/test/Parkinson’s Disease, Alzheimer’s Disease, And Dementia, Including C9orf72 Repeat Expansion Analysis": [
    "AFG3L2",
    "APOE",
    "APP",
    "ATP13A2",
    "ATP1A3",
    "ATP6AP2",
    "C9orf72",
    "CHCHD10",
    "CHMP2B",
    "CP",
    "CSF1R",
    "DCTN1",
    "DNAJC5",
    "DNAJC6",
    "DNMT1",
    "EIF4G1",
    "FBXO7",
    "FUS",
    "GBA1",
    "GCH1",
    "GRN",
    "HTRA2",
    "ITM2B",
    "LRRK2",
    "MAPT",
    "NOTCH3",
    "PARK7",
    "PINK1",
    "PLA2G6",
    "POLG",
    "PRKN",
    "PRKRA",
    "PRNP",
    "PSEN1",
    "PSEN2",
    "SLC20A2",
    "SLC6A3",
    "SNCA",
    "SNCB",
    "SORL1",
    "SQSTM1",
    "SYNJ1",
    "TAF1",
    "TARDBP",
    "TBK1",
    "TH",
    "TREM2",
    "TYROBP",
    "UBQLN2",
    "UCHL1",
    "VCP",
    "VPS13A",
    "VPS35",
    "XPR1"
],
  "/test/Congenital Repeat Expansion Disorders Panel": [
    "FOXL2",
    "HOXD13",
    "PHOX2B",
    "XYLT1",
    "TCF4",
    "GLS",
    "HOXA13",
    "ZIC2",
    "DIP2B",
    "SOX3",
    "PRDM12",
    "EIF4A3",
    "ZIC3"
  ],
  "/test/Repeat Expansion Disorders": [
    "C9orf72",
    "ATXN2",
    "FOXL2",
    "HOXD13",
    "PHOX2B",
    "RFC1",
    "ATN1",
    "XYLT1",
    "ARX",
    "SAMD12",
    "TNRC6A",
    "RAPGEF2",
    "FMR1",
    "FXN",
    "TCF4",
    "GLS",
    "HOXA13",
    "ZIC2",
    "HTT",
    "JPH3",
    "DIP2B",
    "SOX3",
    "CSTB",
    "DMPK",
    "CNBP",
    "NOTCH2NLC",
    "PRDM12",
    "PABPN1",
    "ABCD3",
    "LRP12",
    "GIPC1",
    "NUTM2B-AS1",
    "EIF4A3",
    "NIPA1",
    "AR",
    "ATXN1",
    "ATXN10",
    "PPP2R2B",
    "TBP",
    "FGF14",
    "ATXN3",
    "BEAN1",
    "NOP56",
    "DAB1",
    "ZFHX3",
    "THAP11",
    "CACNA1A",
    "ATXN7",
    "ATXN8",
    "ATXN8OS",
    "AFF2",
    "ZIC3"
  ],
  "/test/Ataxia Expansion Disorders Panel": ["ATXN2", "RFC1", "FMR1", "FXN", "GLS", "ATXN1", "ATXN10", "PPP2R2B", "TBP", "FGF14", "ATXN3", "BEAN1", "NOP56", "DAB1", "ZFHX3", "THAP11", "CACNA1A", "ATXN7", "ATXN8", "ATXN8OS"],
  "/test/Neurological Expansion Disorders Panel": ["C9orf72", "ATXN2", "RFC1", "ATN1", "ARX", "SAMD12", "TNRC6A", "RAPGEF2", "FMR1", "FXN", "TCF4", "GLS", "HTT", "JPH3", "CSTB", "DMPK", "CNBP", "NOTCH2NLC", "PABPN1", "ABCD3", "LRP12", "GIPC1", "NUTM2B-AS1", "NIPA1", "AR", "ATXN1", "ATXN10", "PPP2R2B", "TBP", "FGF14", "ATXN3", "BEAN1", "NOP56", "DAB1", "ZFHX3", "THAP11", "CACNA1A", "ATXN7", "ATXN8", "ATXN8OS"],
  "/test/Neuromuscular Expansion Disorders Panel": ["C9orf72", "ATXN2", "RFC1", "ATN1", "FMR1", "FXN", "GLS", "HTT", "JPH3", "DMPK", "CNBP", "PABPN1", "ABCD3", "LRP12", "GIPC1", "NUTM2B-AS1", "NIPA1", "AR", "ATXN1", "ATXN10", "PPP2R2B", "TBP", "FGF14", "ATXN3", "BEAN1", "NOP56", "DAB1", "ZFHX3", "THAP11", "CACNA1A", "ATXN7", "ATXN8", "ATXN8OS"]
};

testGeneMap["/test/Comprehensive Movement Disorders Panel"] = comprehensiveMovementDisordersGeneTable.map(item => item.gene);

export default testGeneMap;



// WEBPACK FOOTER //
// ./src/utils/testGeneMap.js